import React, { useEffect, useState } from "react";
import DirectEquityFilter from "../../components/DirectEquityFilter/DirectEquityFilter";
import MoneyValue from "../../components/MoneyValue/MoneyValue";
import SelectNuvama from "../../components/SelectNuvama/SelectNuvama";
import FilterAllocation from "../../components/FilterAllocation/FilterAllocation";
import Modal from "../../components/Modal";
import ModalFamily from "../../components/ModalFamily/ModalFamily";
import { ReactComponent as InfinityBackground } from "../../assets/images/svg/infinityBackground.svg";
import {
  allocationColorsStatic,
  family_modal_title,
  filterKeyNameArray,
  filterKeyValue,
  homePageRoute,
} from "../../utils/constants";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import Table from "../../components/Table2";
import infoInfinity from "../../assets/images/svg/infoInfinity.svg";
import infoIcon2 from "../../assets/images/svg/infoIcon2.svg";
import infinityQuickView from "../../assets/images/svg/infinityQuickView.svg";
import qtybag from "../../assets/images/svg/qtybag.svg";
import grayInfoIcon from "../../assets/images/svg/grayInfoIcon.svg";
import { observer } from "mobx-react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  commaSeperated,
  commaSeperated2,
  displayUnit,
  downloadPDFFile,
  excelMaturityDate,
  exportExcel,
  getCurrentDate,
  getDateForSort,
  getDisplayDate,
  getDisplayDateWithoutWholeYear,
  getExcelDate,
  getExcelDate2,
  getExcelNumData2,
  getLimitPer,
  getMaturityDate,
  getPrintDate,
  getSubAssetClasses,
  lakhData,
  numWithUnit,
  pdfMaturityDate,
  //printDocument,
  removeSymbol,
  showDashIfZero,
  showDashIfZeroQty,
  showPercentageDash,
  sortData,
} from "../../utils/functions";
//import PdfTable from "../../components/PdfTable/PdfTable";
import nodataImage from "../../assets/images/svg/nodataImage.svg";
import ArrowButton from "../../components/ArrowButton";
import Tabs from "../../components/Tabs";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import SearchButton from "../../components/SearchButton/SearchButton";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import TransactionModal from "../../components/TransactionModal/TransactionModal";
import ReportsStore from "../../store/ReportsStore";
import { useTransition } from "react";
import NoDataPortfolio from "../../components/NoDataPortfolio/NoDataPortfolio";
import Noportfolio from "../../components/Noportfolio/Noportfolio";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import SubAssetTabs from "../../components/SubAssetTabs/SubAssetTabs";
import TableSkeleton from "../../components/TableSkeleton/TableSkeleton";
import Header from "../../components/Header/Header";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";

const noDataMessage = "No Data Available";

const TextDataWithCustomAnnouncement = ({ text, announcement }) => {
  return (
    <>
      <span className="sr-only">{announcement}</span>
      <span className="instrument_name" aria-hidden={true}>
        {" "}
        {text}
      </span>
    </>
  );
};

const DirectEquitySummary = observer(
  ({ data, isDirectInstru, setIsDirectInstru }) => {
    const [isToggle, setIsToggle] = useState(0);
    const [selectedMember, setSelectedMember] = useState("0");
    const [update, setUpdate] = useState(0);
    const [openFamilyModal, setOpenFamilyModal] = useState(false);
    const [search, setSearch] = useState("");
    const [search2, setSearch2] = useState("");
    const [, startTransition] = useTransition();
    const [isSearchClosed, setIsSearchClosed] = useState(false);
    const { assetClassId, vehicleId, lastMeasureId } = useParams();
    const [tooltipModalOpen, setToolTipModalOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [transactionsData, setTransactionsData] = useState([]);
    const [taxData, setTaxData] = useState([]);
    const location = useLocation();
    const pathArray = location?.pathname?.split("/");
    const [vertualRows, setVertualRows] = useState([]);
    const [vertualRowsInfinity, setVertualRowsInfinity] = useState();
    const [filteredColumn, setFilteredColumn] = useState("current_value");
    const [isAscendingForHeader, setIsAscendingForHeader] = useState(false);
    const [isSortingStarted, setIsSortingStarted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isPageLoaded, setIsPageLoaded] = useState(true);
    const [sortingAnnoucement, setSortingAnnoucement] = useState("");

    const context = useOutletContext();

    const abortController = new AbortController();
    const { signal } = abortController;

    const [filteredColumnInfinity, setFilteredColumnInfinity] =
      useState("current_value");
    const [isAscendingForHeaderInfinity, setIsAscendingForHeaderInfinity] =
      useState(false);
    const navigate = useNavigate();

    const instrumentSummaryId = "instrumentSummaryId";

    const selectedInstrument = UserStore.isHydrated
      ? { ...UserStore.selectedInstrumentVehicle }
      : {};
    const newSetItems =
      UserStore.isHydrated && selectedInstrument?.modifiedVehicleData
        ? [...selectedInstrument?.modifiedVehicleData]
        : [];
    const currentInvestmentReturns =
      selectedInstrument?.vehicleData?.investmentreturn;

    const { vehicleId: subClassId } = UserStore.selectedInfinityInstrument;

    const [selectedTab, setTab] = useState(
      newSetItems?.[0] === undefined || subClassId == "14" || subClassId == "18"
        ? "infinity_pms"
        : "other_pms",
    );

    const transactionModalata = UserStore.instrumentDetails?.transaction;
    const taxLotsData = UserStore.instrumentDetails?.taxLots;
    const modifiedEffectData = UserStore.modifiedData;
    const infinityEffectData = UserStore.modifiedInfinityData;
    const hydrated = UserStore.isHydrated;

    useEffect(() => {
      if (isSearchClosed) {
        setTimeout(() => {
          setIsSearchClosed(false);
        }, 2000);
      } else {
      }
    }, [isSearchClosed]);

    const withNuvama = UserStore.withNuvama;
    const withOthers = UserStore.withOthers;

    const showLocalString = (amt) => {
      if (UserStore.isHybridNormalInstrument) {
        return showDashIfZero(
          Number(amt?.replaceAll(",", "") || 0),
        ).toLocaleString("hi-IN");
      } else {
        return Number(amt?.replaceAll(",", "") || 0).toLocaleString("hi-IN");
      }
    };

    const instrumentNameCellRendererOption3 = (_, data, key) => {
      const getFormattedInstrimentName = () => {
        const inceptionDate = data.actualWholeObject.inceptiondate
          ? getDisplayDate(data.actualWholeObject.inceptiondate)
          : "";
        const maturityDate = data.actualWholeObject.investmentreturn
          .maturity_Date
          ? getMaturityDate(
              data.actualWholeObject.investmentreturn.maturity_Date,
            )
          : "";

        const announcement = `Instrument Name ${data.instrument_name} , Inception Date ${inceptionDate ? inceptionDate : noDataMessage} , With Maturity Date ${maturityDate ? maturityDate : noDataMessage}`;

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="info_tooptip_icon">
              <p
                style={{ visibility: "hidden", position: "absolute" }}
                id={data?.id}
              >
                {data.instrument_name}
              </p>
              {/* <span className="sr-only">Instrument Name</span> */}
              <OverflowingText
                text={data.instrument_name}
                width={getWidth()}
                tooltipOnHover={false}
                position="down"
              >
                <TextDataWithCustomAnnouncement
                  text={data.instrument_name}
                  announcement={announcement}
                />
              </OverflowingText>
            </div>
            <p
              style={{
                color: "#7E8899",
                fontWeight: "500",
                fontSize: "12px",
              }}
              aria-hidden={true}
            >
              {/* <span className="sr-only">, Inception Date</span> */}
              {data.actualWholeObject.inceptiondate ? (
                <span className="date-cell">
                  {getDisplayDate(data.actualWholeObject.inceptiondate)}
                </span>
              ) : (
                <>
                  {/* <span className="sr-only">No Data Available</span> */}
                  <span>{""}</span>
                </>
              )}{" "}
              •{/* <span className="sr-only">With Maturity Date</span> */}
              {data.actualWholeObject.investmentreturn.maturity_Date ? (
                <span className="date-cell">
                  {getMaturityDate(
                    data.actualWholeObject.investmentreturn.maturity_Date,
                  )}
                </span>
              ) : (
                <>
                  {/* <span className="sr-only">No Data Available</span> */}
                  <span>{""}</span>
                </>
              )}
            </p>
          </div>
        );
      };
      return (
        <>
          <div className="instrument_name_cell">
            {getFormattedInstrimentName()}
          </div>
        </>
      );
    };

    const instrumentNameCellRendererOption1 = (_, data, key) => {
      const getFormattedInstrimentName = () => {
        const inceptionDate = data.actualWholeObject.inceptiondate
          ? `(${getDisplayDate(data.actualWholeObject.inceptiondate)})`
          : "";

        const announcement = `Instrument Name ${data.instrument_name} With Inception Date ${inceptionDate}`;

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="info_tooptip_icon">
              <p
                style={{ visibility: "hidden", position: "absolute" }}
                id={data?.id}
              >
                {data.instrument_name}
              </p>
              {/* <span className="sr-only">Instrument Name</span> */}
              <OverflowingText
                text={data.instrument_name}
                width={getWidth()}
                tooltipOnHover={false}
                position="down"
              >
                <TextDataWithCustomAnnouncement
                  text={data.instrument_name}
                  announcement={announcement}
                />
              </OverflowingText>
            </div>
            <p
              style={{
                color: "#7E8899",
                fontWeight: "500",
                fontSize: "12px",
              }}
              aria-hidden={true}
            >
              {/* <span className="sr-only">With Inception Date</span> */}
              {inceptionDate}
            </p>
          </div>
        );
      };

      switch (key) {
        case "par_value":
          return (
            <p className="instrument_name_cell font-roboto">
              {data[key] || "-"}
            </p>
          );
        case "instrument_name":
          return (
            <>
              <div className="instrument_name_cell">
                {getFormattedInstrimentName()}
              </div>
            </>
          );
        case "units":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.units || "-"}
            </p>
          );
        case "qty":
          return <p className="instrument_name_cell font-roboto">{data.qty}</p>;
        case "Avg_buy_price":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.Avg_buy_price}
            </p>
          );
        case "cmp":
          return <p className="instrument_name_cell font-roboto">{data.cmp}</p>;
        case "inv_value":
          return (
            <p className="instrument_name_cell font-roboto">{data.inv_value}</p>
          );
        case "int_div_others":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.int_div_others}
            </p>
          );
        case "unrealised_gain":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.unrealised_gain.text}
              &nbsp;&nbsp;
              {!!data?.unrealised_gain?.subtext &&
              Number(data?.unrealised_gain.subtext) < 0 ? (
                <span className="negative">
                  {data?.unrealised_gain?.subtext}%
                </span>
              ) : (
                <span>{data?.unrealised_gain?.subtext}%</span>
              )}
            </p>
          );
        case "total_gains":
          return (
            <p className="instrument_name_cell  font-roboto">
              {data?.total_gains?.text}
            </p>
          );
        case "realised_Gains":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.realised_Gains}
            </p>
          );
        case "as_on_date":
          return (
            <p className="instrument_name_cell">
              {getDisplayDate(data.as_on_date)}
            </p>
          );
        case "irr":
          return (
            <p className="instrument_name_cell font-roboto">
              {!!data?.irr && Number(data?.irr) < 0 ? (
                <span className="negative">{data?.irr}%</span>
              ) : (
                <span>{data?.irr}%</span>
              )}
            </p>
          );
        default:
          return <p className="instrument_name_cell">{data.invested_value}</p>;
      }
    };

    const instrumentNameCellRendererOption4 = (_, data, key) => {
      const getFormattedInstrimentName = () => {
        const inceptionDate = getDisplayDate(
          data.actualWholeObject.inceptiondate,
        );
        const quantity = data?.actualWholeObject?.instrument?.quantity
          ? commaSeperated2(data?.actualWholeObject?.instrument.quantity)
          : noDataMessage;
        const commitmentValue = data.actualWholeObject.investmentreturn
          .commitment_val?.amount?.actual_value
          ? `${"Commitment Value is"} ${commaSeperated2(
              data.actualWholeObject.investmentreturn.commitment_val?.amount
                ?.value,
            )} ${displayUnit(
              data.actualWholeObject.investmentreturn.commitment_val?.amount
                ?.value_type,
            )}`
          : noDataMessage;

        const announcement = `Instrument Name test ${data?.instrument_name}, Inception Date ${inceptionDate ? inceptionDate : noDataMessage}, Quantity ${quantity} With Commitment Value ${commitmentValue}`;

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingBottom: "15px",
              gap: "0px",
            }}
          >
            <div className="info_tooptip_icon">
              <p
                style={{ visibility: "hidden", position: "absolute" }}
                id={data?.id}
              >
                {data.instrument_name}
              </p>
              {/* <span className="sr-only">Instrument Name</span> */}
              <OverflowingText
                text={data?.instrument_name}
                width={getWidth()}
                tooltipOnHover={false}
                position="down"
              >
                <TextDataWithCustomAnnouncement
                  text={data?.instrument_name}
                  announcement={announcement}
                />
              </OverflowingText>
            </div>
            <p
              style={{
                color: "#7E8899",
                fontWeight: "500",
                fontSize: "12px",
                marginTop: "7px",
              }}
              aria-hidden={true}
            >
              {/* <span className="sr-only">, Inception Date</span> */}
              {getDisplayDate(data.actualWholeObject.inceptiondate)} •{" "}
              {data.actualWholeObject.instrument.quantity && (
                <img src={qtybag} alt="" />
              )}
              &nbsp;
              {/* <span className="sr-only">, Quantity</span> */}
              {data?.actualWholeObject?.instrument?.quantity
                ? commaSeperated2(data?.actualWholeObject?.instrument.quantity)
                : "-"}{" "}
              <p>
                {/* <span className="sr-only">With Commitment Value</span> */}
                {data.actualWholeObject.investmentreturn.commitment_val?.amount
                  ?.actual_value ? (
                  `${"Commitment Value is"} ${commaSeperated2(
                    data.actualWholeObject.investmentreturn.commitment_val
                      ?.amount?.value,
                  )} ${displayUnit(
                    data.actualWholeObject.investmentreturn.commitment_val
                      ?.amount?.value_type,
                  )}`
                ) : (
                  <>
                    {/* <span className="sr-only">No Data Available</span> */}
                    <span></span>
                  </>
                )}
              </p>
            </p>
          </div>
        );
      };

      switch (key) {
        case "par_value":
          return (
            <p className="instrument_name_cell  font-roboto">
              {data[key] || "-"}
            </p>
          );
        case "instrument_name":
          return (
            <>
              <div className="instrument_name_cell">
                {getFormattedInstrimentName()}
              </div>
            </>
          );
        case "units":
          return (
            <p className="instrument_name_cell  font-roboto">
              {data.units || "-"}
            </p>
          );
        case "qty":
          return <p className="instrument_name_cell font-roboto">{data.qty}</p>;
        case "Avg_buy_price":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.Avg_buy_price}
            </p>
          );
        case "cmp":
          return <p className="instrument_name_cell font-roboto">{data.cmp}</p>;
        case "inv_value":
          return (
            <p className="instrument_name_cell font-roboto">{data.inv_value}</p>
          );
        case "int_div_others":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.int_div_others}
            </p>
          );
        case "unrealised_gain":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.unrealised_gain.text}
              &nbsp;&nbsp;
              {!!data?.unrealised_gain?.subtext &&
              Number(data?.unrealised_gain.subtext) < 0 ? (
                <span className="negative">
                  {data?.unrealised_gain?.subtext}%
                </span>
              ) : (
                <span>{data?.unrealised_gain?.subtext}%</span>
              )}
            </p>
          );
        case "total_gains":
          return (
            <p className="instrument_name_cell font-roboto">
              {data?.total_gains?.text}
            </p>
          );
        case "realised_Gains":
          return (
            <p className="instrument_name_cell font-roboto">
              {data.realised_Gains}
            </p>
          );
        case "as_on_date":
          return (
            <p className="instrument_name_cell">
              {getDisplayDate(data.as_on_date)}
            </p>
          );
        case "irr":
          return (
            <p className="instrument_name_cell font-roboto">
              <span>{data.irr}%</span>
            </p>
          );
        default:
          return <p className="instrument_name_cell">{data.invested_value}</p>;
      }
    };

    const instrumentNameCellRenderer = (_, data, key) => {
      const getFormattedInstrimentName = () => {
        return (
          <div className="info_tooptip_icon">
            {data.instrument_name.length > 40 ? (
              <>
                <p>{`${data.instrument_name.slice(0, 40)}...`}</p>
                <div className="info_icon_tooltip">
                  <img className="info_img" src={grayInfoIcon} alt="info" />
                  <p className="td_tooptip">{data.instrument_name}</p>
                </div>
              </>
            ) : (
              data.instrument_name
            )}
          </div>
        );
      };

      switch (key) {
        case "par_value":
          return (
            <p className="instrument_name_cell font-roboto">
              {data[key] || "-"}
            </p>
          );
        case "instrument_name":
          return (
            <>
              <div className="instrument_name_cell">
                {getFormattedInstrimentName()}
              </div>
            </>
          );
        case "units":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument
                ? showDashIfZero(Number(data.units || 0)) === "-"
                  ? "-"
                  : commaSeperated(data.units)
                : commaSeperated(data.units)}
            </p>
          );
        case "qty":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument
                ? showDashIfZero(data?.qty || 0) === "-"
                  ? "-"
                  : commaSeperated(data?.qty)
                : commaSeperated(data?.qty)}
            </p>
          );
        case "Avg_buy_price":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument
                ? showDashIfZero(data.Avg_buy_price || 0) === "-"
                  ? "-"
                  : commaSeperated(data.Avg_buy_price)
                : commaSeperated(data.Avg_buy_price)}
            </p>
          );
        case "cmp":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument
                ? showDashIfZero(data.cmp || 0) === "-"
                  ? "-"
                  : commaSeperated(data?.cmp)
                : commaSeperated(data.cmp)}
            </p>
          );
        case "inv_value":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument
                ? numWithUnit(data?.inv_value, data.invUnit, true)
                : numWithUnit(data?.inv_value, data.invUnit)}
            </p>
          );
        case "int_div_others":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument
                ? numWithUnit(data.int_div_others, data.intDivUnit, true)
                : numWithUnit(data.int_div_others, data.intDivUnit)}
            </p>
          );
        case "unrealised_gain":
          return (
            <p className="instrument_name_cell font-roboto">
              <span className="sr-only">Unrealised Gain</span>
              {UserStore.isHybridNormalInstrument
                ? numWithUnit(
                    data.unrealised_gain.text,
                    data.unrealised_gain.textUnit,
                    true,
                  )
                : numWithUnit(
                    data.unrealised_gain.text,
                    data.unrealised_gain.textUnit,
                  )}
              &nbsp;
              {!!data?.unrealised_gain?.subtext &&
              Number(data?.unrealised_gain.subtext) < 0 ? (
                <>
                  <span className="sr-only">Decreased By</span>
                  <span className="unreal negative">
                    {UserStore.isHybridNormalInstrument
                      ? showPercentageDash(
                          getLimitPer(data?.unrealised_gain?.subtext),
                        )
                      : getLimitPer(data?.unrealised_gain?.subtext) + "%"}
                  </span>
                </>
              ) : (
                <>
                  <span className="sr-only">Increased By</span>
                  <span className="unreal">
                    {UserStore.isHybridNormalInstrument
                      ? showPercentageDash(
                          getLimitPer(data?.unrealised_gain?.subtext),
                        )
                      : getLimitPer(data?.unrealised_gain?.subtext) + "%"}
                  </span>
                </>
              )}
            </p>
          );
        case "total_gains":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument
                ? numWithUnit(
                    data?.total_gains?.text,
                    data?.total_gains.textUnit,
                    true,
                  )
                : numWithUnit(
                    data?.total_gains?.text,
                    data?.total_gains.textUnit,
                  )}
            </p>
          );
        case "realised_Gains":
          return (
            <p className="instrument_name_cell font-roboto">
              {UserStore.isHybridNormalInstrument ||
              selectedInstrument?.assetClassData?.id === 3
                ? numWithUnit(data.realised_Gains, data.realisedUnit, true)
                : numWithUnit(data.realised_Gains, data.realisedUnit)}
            </p>
          );
        case "as_on_date":
          return (
            <p className="instrument_name_cell">
              {getDisplayDate(data.as_on_date)}
            </p>
          );
        case "irr":
          return (
            <p className="instrument_name_cell font-roboto">
              {!!data?.irr && Number(data?.irr) < 0 ? (
                <span className="negative">
                  {UserStore.isHybridNormalInstrument
                    ? showPercentageDash(getLimitPer(data?.irr))
                    : getLimitPer(data?.irr) + "%"}
                </span>
              ) : (
                <span>
                  {" "}
                  {UserStore.isHybridNormalInstrument
                    ? showPercentageDash(getLimitPer(data?.irr))
                    : getLimitPer(data?.irr) + "%"}
                </span>
              )}
            </p>
          );
        default:
          return (
            <p className="instrument_name_cell">
              {UserStore.isHybridNormalInstrument
                ? showDashIfZero(data.invested_value || 0).toLocaleString(
                    "hi-IN",
                  )
                : data.invested_value}
            </p>
          );
      }
    };

    const quantityRender = (_, data, key) => {
      return (
        <p className="instrument_name_cell font-roboto">
          {UserStore.isHybridNormalInstrument
            ? showDashIfZeroQty(data.qty || 0) === "-"
              ? "-"
              : commaSeperated(data?.qty)
            : Number(Number(data.qty).toFixed())?.toLocaleString("hi-IN")}
        </p>
      );
    };

    const currentValueCellRenderer = (_, data = {}, key) => {
      const removeDatePortFolio = (data) => {
        let newData = data?.replaceAll("-", "");
        let asOfDate = UserStore.asOfDate?.replaceAll("-", "");
        if (newData && Number(newData) < Number(asOfDate)) {
          return getDisplayDate(data);
        } else return "";
      };

      switch (key) {
        case "current_value":
          return (
            <>
              <div
                className="instrument_name_cell"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span className="sr-only">Current Value</span>
                <div className=" font-roboto">
                  {numWithUnit(
                    data.current_value?.text,
                    data.current_value?.textUnit,
                    true,
                  )}
                </div>
                {removeDatePortFolio(data.current_value?.subtext || "") !==
                "" ? (
                  <div
                    className="display_date curr_date"
                    style={{ visibility: "visible" }}
                  >
                    {
                      <>
                        <span className="sr-only">With As On Date</span>
                        {removeDatePortFolio(data.current_value?.subtext || "")}
                      </>
                    }
                  </div>
                ) : (
                  <div
                    className="display_date curr_date"
                    style={{ visibility: "hidden" }}
                  >
                    {
                      <>
                        {" "}
                        <span className="sr-only">
                          With As On Date No Data Available
                        </span>
                      </>
                    }
                  </div>
                )}
              </div>
            </>
          );
        case "par_value":
          return (
            <>
              <div
                className="instrument_name_cell"
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <div
                  className={
                    showLocalString(data.par_value) != 0
                      ? "font-roboto"
                      : "display_date"
                  }
                >
                  <span className="sr-only">Par Value</span>
                  {showLocalString(data.par_value) != 0 ? (
                    numWithUnit(data.par_value, data.par_unit)
                  ) : (
                    <>
                      <span className="sr-only">No Data Available</span>
                      <span aria-hidden={true} className="empty-data">
                        {"-"}
                      </span>
                    </>
                  )}
                </div>
                <div className="display_date">
                  <span className="sr-only">Principal payback</span>
                  {showLocalString(data?.principal_paid_amt) != 0 ? (
                    numWithUnit(data.principal_paid_amt, data.pp_unit)
                  ) : (
                    <>
                      <span className="sr-only">No Data Available</span>
                      <span aria-hidden={true} className="empty-data">
                        {"-"}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </>
          );

        default:
          return (
            <p className="instrument_name_cell">
              {showLocalString(data.invested_value)}
            </p>
          );
      }
    };

    const btnCellRenderer = (_, data, key) => {
      return (
        <p
          style={
            key === "instrument4" &&
            data?.actualWholeObject?.investmentreturn?.commitment_val?.amount
              ?.actual_value
              ? { paddingBottom: "27px" }
              : { paddingBottom: "0px" }
          }
        >
          {" "}
          <button
            onClick={() => {
              const _instrument = selectedInstrument?.modifiedVehicleData?.find(
                (item) => {
                  return (
                    data.measure_instr_id === item.measure_instr_id
                    //item.instrument.measureinstrumentid
                  );
                },
              );

              if (
                // selectedInstrument?.assetClassData?.id === 3 ||
                UserStore.isInfinity === "1"
              ) {
                UserStore.setNormalHybirdFlow(true);
              } else {
                UserStore.setNormalHybirdFlow(false);
              }

              UserStore.setSelectedInstrument(_instrument);

              setOpenModal(true);
              PerformanceStore.setCurrentLoader("modalLoader");
              PerformanceStore.setPerformanceLoader("modalLoader", true);

              UserStore.getInstrumentData({
                instrumentId: data.id,
                measureinstrumentid: data.measure_instr_id,
                // instrumentId: _instrument.instrument.id,
                //measureinstrumentid: _instrument.instrument.measureinstrumentid,
                folioNumber:
                  UserStore.isInfinity !== "1" ? false : lastMeasureId,
              });
            }}
            className="accordion_right_btn portfolio_button_animation buttonBlueBorder"
            aria-label={"View Instrument Details"}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
                  fill="white"
                  stroke="#404040"
                />
              </svg>
            </span>
          </button>
        </p>
      );
    };

    const hybridBtnCellRenderer = (_, data, key) => {
      const { assetClassId: classId, vehicleId: subClassId } =
        UserStore.selectedInstrumentVehicle;
      return (
        <div className="hybrid_navigation_container">
          <button
            onClick={() => {
              UserStore.setAssetTabsData([]);
              AuthStore.updateLoadingFullScreen(true);

              UserStore.setInfinityInstrumentIds({
                assetClassId: classId,
                vehicleId: subClassId,
              });

              navigate(
                `/${
                  location?.pathname?.includes("portfolio")
                    ? "portfolio"
                    : homePageRoute
                }/${
                  location?.pathname?.includes("_portfolio")
                    ? "instrument_portfolio"
                    : "instrument"
                }/infinity/${data.actualWholeObject.measureinstrumentid}`,
                {
                  state: {
                    from: "infintiyHoldingsNavigationPath",
                    isWentDirectly: false,
                  },
                },
              );
            }}
            className="view_infinity_holding_btn cursor"
          >
            View Infinity Holdings
          </button>

          <button
            onClick={() => {
              const _instrument = selectedInstrument?.[
                subClassId !== 18 && subClassId !== 14
                  ? "modifiedVehicleData"
                  : "modifiedInfinityInstrument"
              ]?.find(
                (item) => data.measure_instr_id === item.measure_instr_id,
                //item.instrument.measureinstrumentid
              );

              UserStore.setSelectedInstrument(_instrument);
              UserStore.setNormalHybirdFlow(true);

              setOpenModal(true);
              PerformanceStore.setCurrentLoader("modalLoader");
              PerformanceStore.setPerformanceLoader("modalLoader", true);

              UserStore.getInstrumentData({
                instrumentId: data.id,
                measureinstrumentid: data.measure_instr_id,
                // instrumentId: _instrument.instrument.id,
                // measureinstrumentid: _instrument.instrument.measureinstrumentid,
              });
            }}
            className="accordion_right_btn hybrid infinity_pms_btn_animation"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            aria-label={`View Instrument Details Of Instrument ${data.instrument_name}`}
          >
            <svg
              width="8"
              height="12"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
                stroke="#C59331"
              />
            </svg>
          </button>
        </div>
      );
    };

    const columnsOption1ForPdfExcel = [
      {
        header: "Instrument Name",
        label: "Instrument Name",
        key: "instrument_name",
        cellRendererPdf: (data, row, key) => data,
      },
      {
        header: "Inception Date",
        label: "Inception Date ",
        key: "inceptiondate",
        isDate: true,
        base: "-",
        cellRendererExcel: (data, row, key) =>
          getExcelDate2(row.actualWholeObject.inceptiondate, "-"),
        cellRendererPdf: (data, row, key) =>
          getExcelDate(row.actualWholeObject.inceptiondate),
      },
      {
        header: "Qty",
        label: "Qty",
        key: "qty",
        cellRendererPdf: (data, row, key) => {
          return getExcelNumData2(data, UserStore.isHybridNormalInstrument, 0);
        },
      },
      {
        header: "Avg Buy Price",
        label: "Avg Buy Price",
        key: "Avg_buy_price",
        cellRendererPdf: (data, row, key) => {
          return getExcelNumData2(data, UserStore.isHybridNormalInstrument, 2);
        },
      },
      {
        header: "CMP",
        label: "CMP",
        key: "cmp",
        cellRendererPdf: (data, row, key) => {
          return getExcelNumData2(data, UserStore.isHybridNormalInstrument, 2);
        },
      },
      {
        header: "Inv Value",
        label: "Inv Value",
        key: "data_Inv_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Current Value",
        label: "Current Value",
        key: "data_Curr_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "As on Date",
        label: "As on Date",
        key: "as_on_date",
        cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
        cellRendererPdf: (data, row, key) => getExcelDate(data),
      },
      {
        header: "Int/Div/Others",
        label: "Int/Div/Others",
        key: "data_Int_Div",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised Gain",
        label: "Unrealised Gain",
        key: "data_Unre_Gain",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised(%)",
        label: "Unrealised(%)",
        key: "unrealised_percentage",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(getLimitPer(row.unrealised_gain.subtext))
            : getLimitPer(row.unrealised_gain.subtext);
        },
      },
      {
        header: "Realised Gain",
        label: "Realised Gain",
        key: "data_Real_Gai",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "IRR(%)",
        label: "IRR(%)",
        key: "irr",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(getLimitPer(data))
            : getLimitPer(data);
        },
      },
    ];
    const columnsOption2ForPdfExcel = [
      {
        header: "Instrument Name",
        label: "Instrument Name",
        key: "instrument_name",
        cellRendererPdf: (data, row, key) => data,
      },
      {
        header: "Inception Date ",
        label: "Inception Date ",
        key: "inceptiondate",
        isDate: true,
        base: "-",
        cellRendererExcel: (data, row, key) =>
          getExcelDate2(row.actualWholeObject.inceptiondate, "-"),
        cellRendererPdf: (data, row, key) =>
          getExcelDate(row.actualWholeObject.inceptiondate),
      },
      {
        header: "Qty",
        label: "Qty",
        key: "qty",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data
              ? data
              : "-";
        },
      },
      {
        header: "Avg Buy Price",
        label: "Avg Buy Price",
        key: "Avg_buy_price",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
      {
        header: "NAV",
        label: "NAV",
        key: "cmp",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
      {
        header: "Inv Value",
        label: "Inv Value",
        key: "data_Inv_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Current Value",
        label: "Current Value",
        key: "data_Curr_Value",
        cellRendererPdf: (data, row, key) => lakhData(data),
      },
      {
        header: "As on Date",
        label: "As on Date",
        key: "as_on_date",
        cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
        cellRendererPdf: (data, row, key) => getExcelDate(data),
      },
      {
        header: "Int/Div/Others",
        label: "Int/Div/Others",
        key: "data_Int_Div",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(data)
            : lakhData(data);
        },
      },
      {
        header: "Unrealised Gain",
        label: "Unrealised Gain",
        key: "data_Unre_Gain",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised(%)",
        label: "Unrealised(%)",
        key: "unrealised_percentage",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(getLimitPer(row.unrealised_gain.subtext))
            : data;
        },
      },
      {
        header: "Realised Gain",
        label: "Realised Gain",
        key: "data_Real_Gai",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },

      {
        header: "IRR (Since Inception)(%)",
        label: "IRR (Since Inception)(%)",
        key: "irr",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
    ];
    const columnsOption3ForPdfExcel = [
      {
        header: "Instrument Name",
        label: "Instrument Name",
        key: "instrument_name",
        cellRendererPdf: (data, row, key) => data,
      },
      {
        header: "Inception Date",
        label: "Inception Date",
        key: "inceptiondate",
        isDate: true,
        base: "-",
        cellRendererExcel: (data, row, key) =>
          getExcelDate2(row.actualWholeObject.inceptiondate, "-"),
        cellRendererPdf: (data, row, key) =>
          getExcelDate(row.actualWholeObject.inceptiondate),
      },
      {
        header: "Maturity Date",
        label: "Maturity Date",
        key: "inceptiondate",
        isDate: true,
        base: "-",
        cellRendererExcel: (data, row, key) =>
          excelMaturityDate(
            row.actualWholeObject.investmentreturn.maturity_Date,
            "-",
          ),
        cellRendererPdf: (data, row, key) =>
          pdfMaturityDate(row.actualWholeObject.investmentreturn.maturity_Date),
      },

      {
        header: "Qty",
        label: "Qty",
        key: "qty",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
      {
        header: "Avg Buy Price",
        label: "Avg Buy Price",
        key: "Avg_buy_price",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
      {
        header: "CMP",
        label: "CMP",
        key: "cmp",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
      {
        header: "Inv Value",
        label: "Inv Value",
        key: "data_Inv_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Current Value",
        label: "Current Value",
        key: "data_Curr_Value",
        cellRendererPdf: (data, row, key) => lakhData(data),
      },
      {
        header: "As on Date",
        label: "As on Date",
        key: "as_on_date",
        cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
        cellRendererPdf: (data, row, key) => getExcelDate(data),
      },
      {
        header: "Int/Div/Others",
        label: "Int/Div/Others",
        key: "data_Int_Div",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised Gain",
        label: "Unrealised Gain",
        key: "data_Unre_Gain",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised(%)",
        label: "Unrealised(%)",
        key: "unrealised_percentage",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(getLimitPer(row.unrealised_gain.subtext))
            : data;
        },
      },
      {
        header: "Realised Gain",
        label: "Realised Gain",
        key: "data_Real_Gai",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "IRR(%)",
        label: "IRR(%)",
        key: "irr",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
    ];
    const columnsOption4ForPdfExcel = [
      {
        header: "Instrument Name",
        label: "Instrument Name",
        key: "instrument_name",
        cellRendererPdf: (data, row, key) => data,
      },
      {
        header: "Inception Date ",
        label: "Inception Date ",
        key: "inceptiondate",
        isDate: true,
        base: "-",
        cellRendererExcel: (data, row, key) =>
          getExcelDate2(row.actualWholeObject.inceptiondate, "-"),
        cellRendererPdf: (data, row, key) =>
          getExcelDate(row.actualWholeObject.inceptiondate),
      },
      {
        header: "Qty",
        label: "Qty",
        key: "qty",
        cellRendererPdf: (data, row, key) => {
          // return UserStore.isHybridNormalInstrument
          //   ? showDashIfZero(row.actualWholeObject?.instrument?.quantity)
          //:
          return showDashIfZero(row?.actualWholeObject?.instrument?.quantity);
        },
      },
      {
        header: "Commitment Value",
        label: "Commitment Value",
        key: "data_com_value",
        cellRendererPdf: (data, row, key) => {
          const commValue =
            row.actualWholeObject.investmentreturn.commitment_val?.amount
              ?.actual_value || "-";
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(commValue))
            : lakhData(commValue);
        },
      },
      {
        header: "Avg Buy Price",
        label: "Avg Buy Price",
        key: "Avg_buy_price",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
      {
        header: "CMP",
        label: "CMP",
        key: "cmp",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
      {
        header: "Inv Value",
        label: "Inv Value",
        key: "data_Inv_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Current Value",
        label: "Current Value",
        key: "data_Curr_Value",
        cellRendererPdf: (data, row, key) => lakhData(data),
      },
      {
        header: "As on Date",
        label: "As on Date",
        key: "as_on_date",
        cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
        cellRendererPdf: (data, row, key) => getExcelDate(data),
      },
      {
        header: "Par Value",
        label: "Par Value",
        key: "data_Par_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Principal payback",
        label: "Principal payback",
        key: "data_Principle_Amt",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Int/Div/Other",
        label: "Int/Div/Other",
        key: "data_Int_Div",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised Gain",
        label: "Unrealised Gain",
        key: "data_Unre_Gain",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised(%)",
        label: "Unrealised(%)",
        key: "unrealised_percentage",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(getLimitPer(row.unrealised_gain.subtext))
            : data;
        },
      },
      {
        header: "Realised Gain",
        label: "Realised Gain",
        key: "data_Real_Gai",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "IRR(%)",
        label: "IRR(%)",
        key: "irr",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
    ];
    const columnsOption5ForPdfExcel = [
      {
        header: "Instrument Name",
        label: "Instrument Name",
        key: "instrument_name",
        cellRendererPdf: (data, row, key) => data,
      },
      {
        header: "Inception Date ",
        label: "Inception Date ",
        key: "inceptiondate",
        isDate: true,
        base: "-",
        cellRendererExcel: (data, row, key) =>
          getExcelDate2(row.actualWholeObject.inceptiondate, "-"),
        cellRendererPdf: (data, row, key) =>
          getExcelDate(row?.actualWholeObject?.inceptiondate),
      },
      {
        header: "Inv Value",
        label: "Inv Value",
        key: "data_Inv_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Current Value",
        label: "Current Value",
        key: "data_Curr_Value",
        cellRendererPdf: (data, row, key) => lakhData(data),
      },
      {
        header: "As on Date",
        label: "As on Date",
        key: "as_on_date",
        cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
        cellRendererPdf: (data, row, key) => getExcelDate(data),
      },
      {
        header: "Int/Div/Others",
        label: "Int/Div/Others",
        key: "data_Int_Div",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Par Value",
        label: "Par Value",
        key: "data_Par_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Principal payback",
        label: "Principal payback",
        key: "data_Principle_Amt",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised Gain",
        label: "Unrealised Gain",
        key: "data_Unre_Gain",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Unrealised(%)",
        label: "Unrealised(%)",
        key: "unrealised_percentage",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(getLimitPer(row?.unrealised_gain?.subtext))
            : data;
        },
      },
      {
        header: "Realised Gain",
        label: "Realised Gain",
        key: "data_Real_Gai",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "IRR(%)",
        label: "IRR(%)",
        key: "irr",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
    ];

    const hybridColumnsForPdfExcel = [
      {
        label: "Instrument Name",
        key: "instrument_name",
        cellRendererPdf: (data, row, key) => data,
      },
      {
        label: "Inception Date ",
        key: "inceptiondate",
        isDate: true,
        base: "-",
        cellRendererExcel: (data, row, key) =>
          getExcelDate2(row.actualWholeObject.inceptiondate, "-"),
        cellRendererPdf: (data, row, key) =>
          getExcelDate(row?.actualWholeObject?.inceptiondate),
      },
      {
        label: "Inv Value",
        key: "data_Inv_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        label: "Current Value",
        key: "data_Curr_Value",
        cellRendererPdf: (data, row, key) => lakhData(data),
      },
      {
        header: "As on Date",
        label: "As on Date",
        key: "as_on_date",
        cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
        cellRendererPdf: (data, row, key) => getExcelDate(data),
      },
      {
        label: "Int/Div",
        key: "data_Int_Div",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Par Value",
        label: "Par Value",
        key: "data_Par_Value",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        header: "Principal payback",
        label: "Principal payback",
        key: "data_Principle_Amt",
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        label: "Unrealised Gain",
        key: "data_Unre_Gain",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        label: "Unrealised(%)",
        key: "unrealised_percentage",

        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(getLimitPer(row?.unrealised_gain?.subtext))
            : data;
        },
      },
      {
        label: "Realised Gain",
        key: "data_Real_Gai",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? lakhData(showDashIfZero(data))
            : lakhData(data);
        },
      },
      {
        label: "IRR(%)",
        key: "irr",
        sortable: true,
        cellRendererPdf: (data, row, key) => {
          return UserStore.isHybridNormalInstrument
            ? showDashIfZero(data)
            : data;
        },
      },
    ];
    const hybridColumns = [
      {
        headerRendererPdf: () => "Instrument Name",
        label: (
          <>
            Instrument Name
            <br /> Inception Date
          </>
        ),
        key: "instrument_name",
        sortable: true,
        cellRenderer: instrumentNameCellRendererOption1,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "83px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "instrument_nameactualWholeObject",
        multiSortBox: [
          {
            key: "instrument_name",
            show: "Instrument Name",
          },
          {
            key: "actualWholeObject",
            show: "Inception Date",
          },
        ],
        headerLabel: "Sort By Instrument Name With Inception Date",
      },
      {
        label: "Inv Value",
        key: "inv_value",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: (
          <>
            Current Value
            <br /> As on Date
          </>
        ),
        key: "current_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: currentValueCellRenderer,
        headerLabel: "Sort By Current Value with As of Date",
      },

      {
        label: (
          <>
            Int/Div/
            <br /> Others
          </>
        ),
        key: "int_div_others",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: (
          <div style={{ textAlign: "right" }}>
            Par Value
            <br /> Principal payback
          </div>
        ),
        key: "par_value",
        sortable: true,
        cellRenderer: currentValueCellRenderer,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "77px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "par_valueprincipal_paid_amt",
        multiSortBox: [
          {
            key: "par_value",
            show: "Par Value",
          },
          {
            key: "principal_paid_amt",
            show: "Principal payback",
          },
        ],
        headerLabel: "Sort By Par Value With Principal payback",
      },
      {
        label: "Unrealised Gains (%)",
        label2: (
          <>
            Unrealised Gains
            <br />
            <p style={{ textAlign: "end" }}>(%)</p>
          </>
        ),
        key: "unrealised_gain",
        cellRendererPdf: (data, row, key) => data.text,
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        classn: "option6Cls",
        optionNum: 6,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "73px" }
            : { top: "37px", left: "77px" },
        forArrowCheck: "unrealised_gainsubtext",
        multiSortBox: [
          {
            key: "unrealised_gain",
            show: "Unrealised Gains",
          },
          {
            key: "subtext",
            show: "Unrealised Gains (%)",
          },
        ],
        pWidth: "110px",
        headerLabel: "Sort By Unrealised Gains With %",
      },
      {
        label: "Realised Gain",
        label2: (
          <>
            Realised
            <br />
            <p style={{ textAlign: "end" }}>Gain</p>
          </>
        ),
        key: "realised_Gains",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "IRR ",
        key: "irr",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Action",
        key: "instrument",
        cellRenderer: hybridBtnCellRenderer,
      },
    ];
    const columnsOption1 = [
      {
        label: (
          <>
            Instrument Name
            <br /> Inception Date
          </>
        ),

        headerRendererPdf: () => "Instrument Name",
        key: "instrument_name",
        sortable: true,
        cellRenderer: instrumentNameCellRendererOption1,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "73px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "instrument_nameactualWholeObject",
        multiSortBox: [
          {
            key: "instrument_name",
            show: "Instrument Name",
          },
          {
            key: "actualWholeObject",
            show: "Inception Date",
          },
        ],
        headerLabel: "Sort By Instrument Name With Inception Date",
      },
      {
        label: "Qty",
        key: "qty",
        sortable: true,
        cellRenderer: quantityRender,
      },
      {
        label: "Avg Buy Price",
        label2: (
          <>
            Avg Buy
            <br /> <p style={{ textAlign: "end" }}>Price</p>
          </>
        ),

        key: "Avg_buy_price",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "CMP",
        key: "cmp",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Inv Value",
        key: "inv_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        labelPdf: "Current Value",
        label: (
          <span style={{ whiteSpace: "nowrap" }}>
            Current Value
            <br /> As on Date
          </span>
        ),
        key: "current_value",
        sortable: true,
        cellRenderer: currentValueCellRenderer,
        cellRendererPdf: (data, row, key) => data.text,
        headerLabel: "Sort By Current Value with As of Date",
      },

      {
        label: (
          <>
            Int/Div/
            <br /> Others
          </>
        ),
        key: "int_div_others",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        headerLabel: "Sort By Int/Div/Others",
      },
      {
        label: "Unrealised Gains (%)",
        label2: (
          <>
            Unrealised Gains
            <br /> <p style={{ textAlign: "end" }}>(%)</p>
          </>
        ),
        key: "unrealised_gain",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
        classn: "option1Cls",
        optionNum: 1,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "67px" }
            : { top: "37px", left: "77px" },
        forArrowCheck: "unrealised_gainsubtext",
        multiSortBox: [
          {
            key: "unrealised_gain",
            show: "Unrealised Gains",
          },
          {
            key: "subtext",
            show: "Unrealised Gains (%)",
          },
        ],
        pWidth: "110px",
        headerLabel: "Sort By Unrealised Gains With %",
      },
      {
        label: "Realised Gain",
        label2: (
          <>
            Realised
            <br /> <p style={{ textAlign: "end" }}>Gain</p>
          </>
        ),
        key: "realised_Gains",
        sortable: true,

        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "IRR ",
        key: "irr",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Action",
        key: "instrument",
        cellRenderer: btnCellRenderer,
      },
    ];
    const columnsOption2 = [
      {
        headerRendererPdf: () => "Instrument Name",
        label: (
          <>
            Instrument Name
            <br /> Inception Date
          </>
        ),
        key: "instrument_name",
        sortable: true,
        cellRenderer: instrumentNameCellRendererOption1,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "74px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "instrument_nameactualWholeObject",
        multiSortBox: [
          {
            key: "instrument_name",
            show: "Instrument Name",
          },
          {
            key: "actualWholeObject",
            show: "Inception Date",
          },
        ],
        headerLabel: "Sort By Instrument Name With Inception Date",
      },
      {
        label: "Qty",
        key: "qty",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Avg Buy Price",
        label2: (
          <>
            Avg Buy
            <br /> <p style={{ textAlign: "end" }}>Price</p>
          </>
        ),
        key: "Avg_buy_price",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "NAV",
        key: "cmp",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Inv Value",
        key: "inv_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: (
          <span style={{ whiteSpace: "nowrap" }}>
            Current Value
            <br /> As on Date
          </span>
        ),
        labelPdf: "Current Value",
        key: "current_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: currentValueCellRenderer,
        headerLabel: "Sort By Current Value with As of Date",
      },

      {
        label: (
          <>
            Int/Div/
            <br /> Others
          </>
        ),
        key: "int_div_others",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        headerLabel: "Sort By Int/Div/Others",
      },
      {
        label: "Unrealised Gains (%)",
        label2: (
          <>
            Unrealised Gains
            <br />
            <p style={{ textAlign: "end" }}>(%)</p>
          </>
        ),
        key: "unrealised_gain",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
        classn: "option2Cls",
        optionNum: 2,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "70px" }
            : { top: "37px", left: "77px" },
        forArrowCheck: "unrealised_gainsubtext",
        multiSortBox: [
          {
            key: "unrealised_gain",
            show: "Unrealised Gains",
          },
          {
            key: "subtext",
            show: "Unrealised Gains (%)",
          },
        ],
        pWidth: "110px",
        headerLabel: "Sort By Unrealised Gains With %",
      },
      {
        label: "Realised Gain",
        label2: (
          <>
            Realised
            <br />
            <p style={{ textAlign: "end" }}>Gain</p>
          </>
        ),
        key: "realised_Gains",
        sortable: true,

        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: (
          <>
            IRR(Since
            <br />
            Inception)
          </>
        ),
        key: "irr",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        headerLabel: "Sort By IRR (Since Inception)",
      },
      {
        label: "Action",
        key: "instrument",
        cellRenderer: btnCellRenderer,
      },
    ];
    const columnsOption3 = [
      {
        label: (
          <>
            Instrument Name
            <br /> Inception Date • Maturity Date
          </>
        ),
        headerRendererPdf: () => "Instrument Name",
        key: "instrument_name",
        sortable: true,
        cellRenderer: instrumentNameCellRendererOption3,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "83px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "instrument_nameactualWholeObjectmaturity_Date",
        multiSortBox: [
          {
            key: "instrument_name",
            show: "Instrument Name",
          },
          {
            key: "actualWholeObject",
            show: "Inception Date",
          },
          {
            key: "maturity_Date",
            show: "Maturity Date",
          },
        ],
        pWidth: "161px",
        headerLabel:
          "Sort By Instrument Name With Inception Date and Maturity Date",
      },
      {
        label: "Qty",
        key: "qty",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Avg Buy Price",
        label2: (
          <>
            Avg Buy
            <br />
            <p style={{ textAlign: "end" }}>Price</p>
          </>
        ),
        key: "Avg_buy_price",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "CMP",
        key: "cmp",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Inv Value",
        key: "inv_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: (
          <span style={{ whiteSpace: "nowrap" }}>
            Current Value
            <br /> As on Date
          </span>
        ),
        labelPdf: "Current Value",
        key: "current_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: currentValueCellRenderer,
        headerLabel: "Sort By Current Value with As of Date",
      },

      {
        label: (
          <>
            Int/Div/
            <br /> Others
          </>
        ),
        key: "int_div_others",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        headerLabel: "Sort By Int/Div/Others",
      },
      {
        label: "Unrealised Gains (%)",
        label2: (
          <>
            Unrealised Gains
            <br />
            <p style={{ textAlign: "end" }}>(%)</p>
          </>
        ),
        key: "unrealised_gain",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
        classn: "option3Cls",
        optionNum: 3,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "37px", left: "70px" }
            : { top: "37px", left: "77px" },
        forArrowCheck: "unrealised_gainsubtext",
        multiSortBox: [
          {
            key: "unrealised_gain",
            show: "Unrealised Gains",
          },
          {
            key: "subtext",
            show: "Unrealised Gains (%)",
          },
        ],
        pWidth: "110px",
        headerLabel: "Sort By Unrealised Gains With %",
      },
      {
        label: "Realised Gain",
        label2: (
          <>
            Realised
            <br />
            <p style={{ textAlign: "end" }}>Gain</p>
          </>
        ),
        key: "realised_Gains",
        sortable: true,

        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "IRR ",
        key: "irr",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Action",
        key: "instrument",
        cellRenderer: btnCellRenderer,
      },
    ];
    const columnsOption4 = [
      {
        headerRendererPdf: () => "Instrument Name",
        label: (
          <>
            Instrument Name
            <br /> Inception Date • Qty
          </>
        ),
        key: "instrument_name",
        sortable: true,
        cellRenderer: instrumentNameCellRendererOption4,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "83px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "instrument_nameactualWholeObjectinstrument",
        multiSortBox: [
          {
            key: "instrument_name",
            show: "Instrument Name",
          },
          {
            key: "actualWholeObject",
            show: "Inception Date",
          },
          {
            key: "instrument",
            show: "Quantity",
          },
        ],
        pWidth: "110px",
        headerLabel: "Sort By Instrument Name With Inception Date and Quantity",
      },
      {
        label: "Avg Buy Price",
        label2: (
          <>
            Avg Buy
            <br />
            <p style={{ textAlign: "end" }}>Price</p>
          </>
        ),
        key: "Avg_buy_price",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "CMP",
        key: "cmp",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Inv Value",
        key: "inv_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: (
          <span style={{ whiteSpace: "nowrap" }}>
            Current Value
            <br /> As on Date
          </span>
        ),
        key: "current_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: currentValueCellRenderer,
        headerLabel: "Sort By Current Value with As of Date",
      },
      {
        label: (
          <div style={{ textAlign: "right" }}>
            Par Value
            <br /> Principal payback
          </div>
        ),
        key: "par_value",
        sortable: true,
        cellRenderer: currentValueCellRenderer,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "70px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "par_valueprincipal_paid_amt",
        multiSortBox: [
          {
            key: "par_value",
            show: "Par Value",
          },
          {
            key: "principal_paid_amt",
            show: "Principal payback",
          },
        ],
        headerLabel: "Sort By Par Value With Principal payback",
      },
      {
        label: (
          <>
            Int/Div/
            <br /> Others
          </>
        ),
        key: "int_div_others",

        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        headerLabel: "Sort By Int/Div/Others",
      },
      {
        label: "Unrealised Gains (%)",
        label2: (
          <>
            Unrealised Gains
            <br />
            <p style={{ textAlign: "end" }}>(%)</p>
          </>
        ),
        key: "unrealised_gain",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
        classn: "option4Cls",
        optionNum: 4,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "67px" }
            : { top: "37px", left: "77px" },
        forArrowCheck: "unrealised_gainsubtext",
        multiSortBox: [
          {
            key: "unrealised_gain",
            show: "Unrealised Gains",
          },
          {
            key: "subtext",
            show: "Unrealised Gains (%)",
          },
        ],
        pWidth: "110px",
        headerLabel: "Sort By Unrealised Gains With %",
      },
      {
        label: "Realised Gain",
        label2: (
          <>
            Realised
            <br />
            <p style={{ textAlign: "end" }}>Gain</p>
          </>
        ),
        key: "realised_Gains",
        sortable: true,

        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "IRR ",
        key: "irr",
        sortable: true,

        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Action",
        key: "instrument4",
        cellRenderer: btnCellRenderer,
      },
    ];
    const columsOption5 = [
      {
        headerRendererPdf: () => "Instrument Name",
        label: (
          <>
            Instrument Name
            <br /> Inception Date
          </>
        ),
        key: "instrument_name",
        sortable: true,
        cellRenderer: instrumentNameCellRendererOption1,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "83px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "instrument_nameactualWholeObject",
        multiSortBox: [
          {
            key: "instrument_name",
            show: "Instrument Name",
          },
          {
            key: "actualWholeObject",
            show: "Inception Date",
          },
        ],
        headerLabel: "Sort By Instrument Name With Inception Date",
      },
      {
        label: "Inv Value",
        key: "inv_value",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: (
          <span style={{ whiteSpace: "nowrap" }}>
            Current Value
            <br /> As on Date
          </span>
        ),
        key: "current_value",
        sortable: true,
        cellRendererPdf: (data, row, key) => data.text,
        cellRenderer: currentValueCellRenderer,
        headerLabel: "Sort By Current Value with As of Date",
      },

      {
        label: (
          <>
            Int/Div/
            <br /> Others
          </>
        ),
        key: "int_div_others",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        headerLabel: "Sort By Int/Div/Others",
      },
      {
        label: (
          <div style={{ textAlign: "right" }}>
            Par Value
            <br /> Principal payback
          </div>
        ),
        key: "par_value",
        sortable: true,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "45px", left: "70px" }
            : { top: "45px", left: "77px" },
        forArrowCheck: "par_valueprincipal_paid_amt",
        cellRenderer: currentValueCellRenderer,
        multiSortBox: [
          {
            key: "par_value",
            show: "Par Value",
          },
          {
            key: "principal_paid_amt",
            show: "Principal payback",
          },
        ],
        headerLabel: "Sort By Par Value With Principal payback",
      },
      {
        label: "Unrealised Gains (%)",
        label2: (
          <>
            Unrealised Gains
            <br />
            <p style={{ textAlign: "end" }}>(%)</p>
          </>
        ),
        key: "unrealised_gain",
        cellRendererPdf: (data, row, key) => data.text,
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
        classn: "option5Cls",
        optionNum: 5,
        isMultipleSort: true,
        position:
          document.documentElement.clientWidth < 1200
            ? { top: "37px", left: "70px" }
            : { top: "37px", left: "77px" },
        forArrowCheck: "unrealised_gainsubtext",
        multiSortBox: [
          {
            key: "unrealised_gain",
            show: "Unrealised Gains",
          },
          {
            key: "subtext",
            show: "Unrealised Gains (%)",
          },
        ],
        pWidth: "110px",
        headerLabel: "Sort By Unrealised Gains With %",
      },
      {
        label: "Realised Gain",
        label2: (
          <>
            Realised
            <br />
            <p style={{ textAlign: "end" }}>Gain</p>
          </>
        ),
        key: "realised_Gains",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "IRR ",
        key: "irr",
        sortable: true,
        cellRenderer: instrumentNameCellRenderer,
      },
      {
        label: "Action",
        key: "instrument",
        cellRenderer: btnCellRenderer,
      },
    ];

    const option5Details2 = ["93", "79"];
    const option1Details2 = ["15"];
    const option2Details2 = ["51", "53", "60", "58", "57", "95"];
    const option3Details2 = ["7", "36", "38", "52", "61", "81", "72"];
    const option4Details2 = [
      "2",
      "13",
      "17",
      "55",
      "54",
      "62",
      "63",
      "64",
      "66",
      "69",
      "70",
      "76",
      "83",
      "88",
    ];

    const getFirstTimePdfTableData = () => {
      const rowData = UserStore.selectedInstrumentVehicle?.modifiedVehicleData;

      if (rowData)
        return [...rowData]
          ?.sort(
            (a, b) => Number(a?.data_Curr_Value) - Number(b?.data_Curr_Value),
          )
          .reverse();
    };

    const getColumns = () => {
      switch (String(selectedInstrument?.vehicleData?.id)) {
        case "1":
          return columnsOption1;
        case "2":
          return columnsOption4;
        case "7":
          return columnsOption3;
        case "13":
          return columnsOption4;
        case "14":
          return hybridColumns; // col5
        case "15":
          return columnsOption1;
        case "16":
          return columnsOption1;
        case "17":
          return columnsOption4;
        case "18":
          return hybridColumns; // col5
        case "36":
          return columnsOption3;
        case "38":
          return columnsOption3;
        case "51":
          return columnsOption2;
        case "52":
          return columnsOption3;
        case "53":
          return columnsOption2;
        case "54":
          return columnsOption4;
        case "55":
          return columnsOption4;
        case "56":
          return columnsOption1;
        case "57":
          return columnsOption2;
        case "58":
          return columnsOption2;
        case "59":
          return columnsOption1;
        case "60":
          return columnsOption2;
        case "61":
          return columnsOption3;
        case "62":
          return columnsOption4;
        case "63":
          return columnsOption4;
        case "64":
          return columnsOption4;
        case "65":
          return columnsOption1;
        case "66":
          return columnsOption4;
        case "67":
          return columnsOption1;
        case "68":
          return columnsOption1;
        case "69":
          return columnsOption4;
        case "70":
          return columnsOption4;

        case "72":
          return columnsOption3;

        case "75":
          return columnsOption1;
        case "76":
          return columnsOption4;

        case "78":
          return columnsOption1;
        case "79":
          return hybridColumns; // col5
        case "80":
          return columnsOption1;
        case "81":
          return columnsOption3;
        case "82":
          return columnsOption1;
        case "83":
          return columnsOption4;
        case "85":
          return columnsOption1;
        case "88":
          return columnsOption4;
        case "90":
          return columnsOption1;
        case "91":
          return columnsOption1;
        case "93":
          return columsOption5;
        case "94":
          return columnsOption3;
        case "95":
          return columnsOption2;

        default:
          return columnsOption1;
      }
    };

    const getClass = () => {
      const instruId = String(selectedInstrument?.vehicleData?.id || "");

      // if (selectedInstrument?.assetClassData?.id === 3) {
      //   return "option6";
      // }

      if (UserStore.isInfinity === "1") {
        return "option1";
      } else if (selectedInstrument?.assetClassData?.assetClass?.name === "") {
        return "";
      } else {
        if (option1Details2.includes(instruId)) return "option1";
        if (option3Details2.includes(instruId)) return "option3";
        if (option2Details2.includes(instruId)) return "option1 option2";
        if (option4Details2.includes(instruId)) return "option4";
        if (instruId === "79") return "option6";
        if (option5Details2.includes(instruId)) return "option5";
        else return "option1";
      }
    };

    const getColumnsForPdf = () => {
      if (UserStore.isInfinity === "1") return columnsOption1ForPdfExcel;
      else if (
        selectedInstrument?.assetClassData?.id === 3 &&
        String(selectedInstrument?.vehicleData?.id) === "79"
      ) {
        return hybridColumnsForPdfExcel;
      } else {
        switch (String(selectedInstrument?.vehicleData?.id)) {
          case "2":
            return columnsOption4ForPdfExcel;
          case "7":
            return columnsOption3ForPdfExcel;
          case "13":
            return columnsOption4ForPdfExcel;
          case "14":
            return columnsOption5ForPdfExcel;
          case "15":
            return columnsOption1ForPdfExcel;
          case "16":
            return columnsOption1ForPdfExcel;
          case "17":
            return columnsOption4ForPdfExcel;
          case "18":
            return columnsOption5ForPdfExcel;
          case "36":
            return columnsOption3ForPdfExcel;
          case "38":
            return columnsOption3ForPdfExcel;
          case "51":
            return columnsOption2ForPdfExcel;
          case "52":
            return columnsOption3ForPdfExcel;
          case "53":
            return columnsOption2ForPdfExcel;
          case "54":
            return columnsOption4ForPdfExcel;
          case "55":
            return columnsOption4ForPdfExcel;
          case "56":
            return columnsOption1ForPdfExcel;
          case "57":
            return columnsOption2ForPdfExcel;
          case "58":
            return columnsOption2ForPdfExcel;
          case "59":
            return columnsOption1ForPdfExcel;
          case "60":
            return columnsOption2ForPdfExcel;
          case "61":
            return columnsOption3ForPdfExcel;
          case "62":
            return columnsOption4ForPdfExcel;
          case "63":
            return columnsOption4ForPdfExcel;
          case "64":
            return columnsOption4ForPdfExcel;
          case "65":
            return columnsOption1ForPdfExcel;
          case "66":
            return columnsOption4ForPdfExcel;
          case "67":
            return columnsOption1ForPdfExcel; // n
          case "68":
            return columnsOption1ForPdfExcel; // n
          case "69":
            return columnsOption4ForPdfExcel;
          case "70":
            return columnsOption4ForPdfExcel;

          case "72":
            return columnsOption3ForPdfExcel;
          case "75":
            return columnsOption1ForPdfExcel;
          case "76":
            return columnsOption4ForPdfExcel;
          case "78":
            return columnsOption1ForPdfExcel;
          case "79":
            return columnsOption5ForPdfExcel;
          case "80":
            return columnsOption1ForPdfExcel;

          case "81":
            return columnsOption3ForPdfExcel;
          case "82":
            return columnsOption1ForPdfExcel;
          case "83":
            return columnsOption4ForPdfExcel;
          case "85":
            return columnsOption1ForPdfExcel; // n
          case "88":
            return columnsOption4ForPdfExcel;
          case "90":
            return columnsOption1ForPdfExcel; // n
          case "91":
            return columnsOption1ForPdfExcel; // n
          case "93":
            return columnsOption5ForPdfExcel;

          case "93":
            return columnsOption5ForPdfExcel;
          case "94":
            return columnsOption3ForPdfExcel;
          case "95":
            return columnsOption2ForPdfExcel;

          default:
            return columnsOption1ForPdfExcel;
        }
      }
    };

    const handleWealth = () => {
      UserStore.changeIsLiveToZero("0", false);
      // UserStore.addToPortfolio({
      //   portfolioGraphSeries: null,
      // });
      UserStore.setPortfolioTabsStatusDefault();
      UserStore.onFilterChange({ signal });

      UserStore.getReportsPersistData();
    };

    const OthersModalContent = () => {
      const handleCloseOthersModal = () => {
        setToolTipModalOpen(false);
      };

      return (
        <div className="others_content_wrapper">
          <p>
            Current Value will differ from Infinity portal due to one of the
            following reasons:
          </p>
          <div className="others_list_items">
            <p>1. Valuation method variation</p>
            <p>2. Valuation upload delays</p>
            <p>
              3. Newly created/bought instruments may take some time to reflect
            </p>
          </div>
          <div className="got_it_button">
            <ArrowButton
              type="next"
              label="Okay, Got it"
              onClick={handleCloseOthersModal}
            />
          </div>
        </div>
      );
    };

    const handleSortForTransaction = (filterType) => {
      setFilteredColumn(filterType);
      setIsAscendingForHeader(!isAscendingForHeader);
    };

    const handleSortForInfinity = (filterType) => {
      setFilteredColumnInfinity(filterType);
      setIsAscendingForHeaderInfinity(!isAscendingForHeaderInfinity);
    };

    const getPortfolioReportName = () => {
      const famName =
        UserStore.getData === "fam"
          ? UserStore.userData?.family_name
          : UserStore.userData?.full_name;
      return !UserStore.isHybridNormalInstrument
        ? `Portfolio Summary - ${famName}`
        : `Infinity Portfolio Summary - ${famName}`;
    };

    const getReportsSheetName = ({ isInfinity, selectedInstrument }) => {
      const symbolRemovedAssetClassName = removeSymbol(
        selectedInstrument?.vehicleData?.assetClass?.name,
      );

      return `${
        isInfinity !== "1"
          ? `${symbolRemovedAssetClassName} Instrument Summary`
          : `Infinity - ${symbolRemovedAssetClassName} Instrument Summary`
      }`;
    };

    useEffect(() => {
      ReportsStore.updateTableDataLoader(true);
      window.scrollTo(0, 0);
      document.addEventListener("scroll", () => {
        if (document.documentElement.scrollTop === 0) {
          setVertualRows(UserStore.modifiedData?.slice(0, 100));
        }
        if (
          document.documentElement.scrollHeight -
            document.documentElement.scrollTop +
            document.documentElement.clientHeight <
            2000 &&
          UserStore.modifiedData?.length
        ) {
          if (vertualRows) {
            setVertualRows((prev) => {
              if (prev) {
                return [
                  ...prev,
                  ...UserStore.modifiedData.slice(
                    prev?.length,
                    prev?.length + 100,
                  ),
                ];
              }
            });
          }
        }
      });

      return () => {
        UserStore.setFilterStatus(false);
      };
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      ReportsStore.updateTableDataLoader(true);
      window.scrollTo(0, 0);
      document.addEventListener("scroll", () => {
        if (document.documentElement.scrollTop === 0) {
          setVertualRowsInfinity(UserStore.modifiedInfinityData?.slice(0, 100));
        }
        if (
          document.documentElement.scrollHeight -
            document.documentElement.scrollTop +
            document.documentElement.clientHeight <
            2000 &&
          UserStore.modifiedInfinityData?.length
        ) {
          if (vertualRows) {
            setVertualRows((prev) => {
              if (prev) {
                return [
                  ...prev,
                  ...UserStore.modifiedInfinityData.slice(
                    prev?.length,
                    prev?.length + 100,
                  ),
                ];
              }
            });
          }
        }
      });

      return () => {
        abortController.abort();
      };
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      //  let mainData = UserStore.rememberedInfinityData;
      let mainData =
        UserStore.selectedInstrumentVehicle?.modifiedInfinityInstrument;

      if (UserStore.isHydrated && PerformanceStore.isHydrated) {
        let rowData = [];

        rowData = mainData?.filter((data) => {
          if (!search2) return true;
          else
            return data?.instrument_name
              ?.toLowerCase()
              ?.includes(search2?.toLowerCase());
        });

        if (rowData?.length) {
          let sortedColumnData = [];

          if (filteredColumnInfinity === "subtext") {
            sortedColumnData = [...rowData]?.sort(
              (a, b) =>
                Number(a?.unrealised_gain?.[filteredColumnInfinity]) -
                Number(b?.unrealised_gain?.[filteredColumnInfinity]),
            );
            UserStore.updateModifiedInfinityData(
              isAscendingForHeaderInfinity
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filteredColumnInfinity === "maturity_Date") {
            sortedColumnData = [...rowData]?.sort((a, b) => {
              let aa = getDateForSort(
                a?.actualWholeObject?.investmentreturn.maturity_Date,
              );
              let bb = getDateForSort(
                b?.actualWholeObject?.investmentreturn.maturity_Date,
              );
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
            UserStore.updateModifiedInfinityData(
              isAscendingForHeaderInfinity
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filteredColumnInfinity === "actualWholeObject") {
            sortedColumnData = [...rowData]?.sort((a, b) => {
              let aa = a?.[filteredColumnInfinity]?.inceptiondate
                ?.split("-")
                ?.join();
              let bb = b?.[filteredColumnInfinity]?.inceptiondate
                ?.split("-")
                ?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
            UserStore.updateModifiedInfinityData(
              isAscendingForHeaderInfinity
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filteredColumnInfinity === "instrument") {
            sortedColumnData = [...rowData]?.sort(
              (a, b) =>
                Number(a?.actualWholeObject.instrument.quantity) -
                Number(b?.actualWholeObject.instrument.quantity),
            );
            UserStore.updateModifiedInfinityData(
              isAscendingForHeaderInfinity
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filterKeyNameArray.includes(filteredColumnInfinity)) {
            UserStore.updateModifiedInfinityData(
              sortData({
                sortingOrder: isAscendingForHeaderInfinity,
                rowData,
                keyName: filteredColumnInfinity,
                type:
                  filteredColumnInfinity === "instrument_name"
                    ? "string"
                    : "number",
                keyName2: false,
              }),
            );
          } else {
            UserStore.updateModifiedInfinityData(
              sortData({
                sortingOrder: isAscendingForHeaderInfinity,
                rowData,
                keyName: false,
                type:
                  filteredColumnInfinity === "instrument_name"
                    ? "string"
                    : "number",
                keyName2: filterKeyValue[filteredColumnInfinity],
              }),
            );
          }
        } else {
          mainData && setLoading(false);
          UserStore.updateModifiedInfinityData([]);
        }
      }
    }, [
      filteredColumnInfinity,
      isAscendingForHeaderInfinity,
      search2,
      UserStore.selectedInstrumentVehicle,
    ]);

    useEffect(() => {
      let mainData = UserStore.selectedInstrumentVehicle?.modifiedVehicleData;
      if (UserStore.isHydrated && PerformanceStore.isHydrated) {
        // let mainData = UserStore.rememberedModifiedData;

        let rowData = [];
        rowData = mainData?.filter((data) => {
          if (!search2) return true;
          else
            return data?.instrument_name
              ?.toLowerCase()
              ?.includes(search2?.toLowerCase());
        });

        if (rowData?.length) {
          let sortedColumnData = [];

          if (isPageLoaded) {
            setIsSortingStarted(true);
            setLoading(true);
            setIsPageLoaded(false);
          }
          if (filteredColumn === "subtext") {
            sortedColumnData = [...rowData]?.sort(
              (a, b) =>
                Number(a?.unrealised_gain?.[filteredColumn]) -
                Number(b?.unrealised_gain?.[filteredColumn]),
            );
            UserStore.updateModifiedData(
              isAscendingForHeader
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filteredColumn === "maturity_Date") {
            sortedColumnData = [...rowData]?.sort((a, b) => {
              let aa = getDateForSort(
                a?.actualWholeObject?.investmentreturn.maturity_Date,
              );
              let bb = getDateForSort(
                b?.actualWholeObject?.investmentreturn.maturity_Date,
              );
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
            UserStore.updateModifiedData(
              isAscendingForHeader
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filteredColumn === "actualWholeObject") {
            sortedColumnData = [...rowData]?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.inceptiondate?.split("-")?.join();
              let bb = b?.[filteredColumn]?.inceptiondate?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
            UserStore.updateModifiedData(
              isAscendingForHeader
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filteredColumn === "instrument") {
            sortedColumnData = [...rowData]?.sort(
              (a, b) =>
                Number(a?.actualWholeObject.instrument.quantity) -
                Number(b?.actualWholeObject.instrument.quantity),
            );
            UserStore.updateModifiedData(
              isAscendingForHeader
                ? sortedColumnData
                : sortedColumnData.reverse(),
            );
          } else if (filterKeyNameArray.includes(filteredColumn)) {
            UserStore.updateModifiedData(
              sortData({
                sortingOrder: isAscendingForHeader,
                rowData,
                keyName: filteredColumn,
                type:
                  filteredColumn === "instrument_name" ? "string" : "number",
                keyName2: false,
              }),
            );
          } else {
            UserStore.updateModifiedData(
              sortData({
                sortingOrder: isAscendingForHeader,
                rowData,
                keyName: false,
                type:
                  filteredColumn === "instrument_name" ? "string" : "number",
                keyName2: filterKeyValue[filteredColumn],
              }),
            );
          }
        } else {
          mainData && setLoading(false);
          UserStore.updateModifiedData([]);
        }
      }

      // eslint-disable-next-line
    }, [
      filteredColumn,
      isAscendingForHeader,
      search2,
      //instruments,
      UserStore.selectedInstrumentVehicle,
    ]);

    useEffect(() => {
      setVertualRows(UserStore.modifiedData?.slice(0, 100));
      if (isSortingStarted) {
        setLoading(false);
        setIsSortingStarted(false);
      }
    }, [modifiedEffectData]);

    useEffect(() => {
      setVertualRowsInfinity(UserStore.modifiedInfinityData?.slice(0, 100));
    }, [infinityEffectData]);

    useEffect(() => {
      setUpdate((prev) => prev + 1);
      return () => {
        if (UserStore.isInfinity === "1") {
          UserStore.setAssetTabsData([]);
          UserStore.setIsNavigated(false);
          UserStore.setOpenId("infinityOpenID", assetClassId);
          UserStore.setOpenId("portfolioOpenID", null);
        } else {
          UserStore.setOpenId("portfolioOpenID", assetClassId);
          UserStore.setOpenId("infinityOpenID", null);
        }
      };
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      setUpdate(1);
    }, [hydrated]);

    useEffect(() => {
      if (UserStore.isHydrated) {
        const selectedInstrument =
          UserStore.selectedInstrumentVehicle?.assetClassData;
        const selectedVehicle =
          UserStore.selectedInstrumentVehicle?.vehicleData;

        if (UserStore.isHybridNormalInstrument) {
          UserStore.setPortfolioPath(
            {
              path1: {
                path: `/${
                  location?.pathname?.includes("portfolio")
                    ? "portfolio"
                    : homePageRoute
                }/instrument/infinity/${lastMeasureId}`,
                show: `Infinity Holdings`,
                state: {
                  from: `${
                    location?.pathname?.includes("portfolio")
                      ? "portfolio"
                      : homePageRoute
                  }`,
                  open2: selectedInstrument?.assetClass?.id,
                },
              },
              path2: {
                path: `/${
                  location?.pathname?.includes("portfolio")
                    ? "portfolio"
                    : homePageRoute
                }/subassetclassdetailsinfiniity/${selectedInstrument?.id}/${
                  selectedVehicle?.id
                }/${lastMeasureId}`,
                show: `${selectedInstrument?.assetClass?.name}-${selectedVehicle?.assetClass?.name}`,
                state: {
                  from: `${
                    location?.pathname?.includes("portfolio")
                      ? "portfolio"
                      : homePageRoute
                  }`,
                  open2: selectedInstrument?.assetClass?.id,
                },
              },
            },
            true,
          );
        }
        setTab(
          !newSetItems?.length || subClassId == "14" || subClassId == "18"
            ? "infinity_pms"
            : "other_pms",
        );
      }
      // eslint-disable-next-line
    }, [UserStore.isHydrated, UserStore.selectedInstrumentVehicle]);

    const getWidth = () => {
      if (
        document.documentElement.clientWidth > 990 &&
        document.documentElement.clientWidth < 1180 &&
        update
      )
        return 201;
      else if (
        document.documentElement.clientWidth > 1181 &&
        document.documentElement.clientWidth < 1200 &&
        update
      )
        return 221;
      else if (
        document.documentElement.clientWidth < 1400 &&
        document.documentElement.clientWidth > 1200 &&
        update
      ) {
        if (
          (selectedInstrument?.vehicleData?.assetClass?.name === "Equity-PMS" ||
            selectedInstrument?.vehicleData?.assetClass?.name === "Debt-PMS") &&
          selectedTab === "other_pms"
        ) {
          return 301;
        } else {
          return 221;
        }
      } else if (
        document.documentElement.clientWidth < 1600 &&
        document.documentElement.clientWidth > 1400 &&
        update
      ) {
        if (
          (selectedInstrument?.vehicleData?.assetClass?.name === "Equity-PMS" ||
            selectedInstrument?.vehicleData?.assetClass?.name === "Debt-PMS") &&
          selectedTab === "other_pms"
        ) {
          return 301;
        } else {
          return 221;
        }
      } else if (
        document.documentElement.clientWidth < 1990 &&
        document.documentElement.clientWidth > 1600 &&
        update
      ) {
        if (
          (selectedInstrument?.vehicleData?.assetClass?.name === "Equity-PMS" ||
            selectedInstrument?.vehicleData?.assetClass?.name === "Debt-PMS") &&
          selectedTab === "other_pms"
        ) {
          return 301;
        } else {
          return 221;
        }
      } else if (
        document.documentElement.clientWidth < 5800 &&
        document.documentElement.clientWidth > 1990 &&
        update
      ) {
        if (
          (selectedInstrument?.vehicleData?.assetClass?.name === "Equity-PMS" ||
            selectedInstrument?.vehicleData?.assetClass?.name === "Debt-PMS") &&
          selectedTab === "other_pms"
        ) {
          return 301;
        } else {
          return 221;
        }
      }
    };

    useEffect(() => {
      const localData = UserStore.instrumentDetails?.transaction
        ? UserStore.instrumentDetails?.transaction
        : [];
      setTransactionsData([...localData]);
    }, [transactionModalata]);

    useEffect(() => {
      const localData = UserStore.instrumentDetails?.taxLots
        ? UserStore.instrumentDetails?.taxLots
        : [];
      setTaxData([...localData]);
    }, [taxLotsData]);

    useEffect(() => {
      const abortController = new AbortController();
      const { signal } = abortController;

      if (UserStore.isHydrated && PerformanceStore.isHydrated) {
        if (
          pathArray[2] === "subassetclassdetailsQuick" ||
          pathArray[2] === "subassetclassdetails_portfolio" ||
          pathArray[2] === "subassetclassdetailshome" ||
          pathArray[2] === "global-sub-asset-class"
        ) {
          if (
            pathArray[2] === "subassetclassdetails_portfolio" ||
            pathArray[2] === "global-sub-asset-class"
          ) {
            UserStore.setRef(Number(vehicleId), "normal");
            PerformanceStore.loaderCloseOnFail();
            UserStore.changeIsLiveToZero("0", false);
            UserStore.setInfinity("0");
            UserStore.setNormalHybirdFlow(false);

            let classId = null;
            let subClassId = null;
            const { assetClassId: assetId, vehicleId: subAssetId } =
              UserStore.selectedInfinityInstrument;
            if (assetId) {
              classId = assetId;
              subClassId = subAssetId;
            } else {
              classId = assetClassId;
              subClassId = vehicleId;
            }

            UserStore.onToggleLive({
              assetClassId: classId,
              vehicleId: subClassId,
              measureId: pathArray[5],
              isInfinity: UserStore.isInfinity,
              signal,
            });
          }
          if (
            pathArray[2] === "subassetclassdetailsQuick" ||
            pathArray[2] === "subassetclassdetailshome"
          ) {
            UserStore.changeIsLiveToZero("0", false);
            UserStore.setInfinity("0");
            UserStore.setNormalHybirdFlow(false);

            UserStore.getInfinityData({
              onSuccess: () => {},
              onFail: () => {},
              page:
                pathArray[2] === "subassetclassdetailsQuick"
                  ? "portfolio"
                  : homePageRoute,
              signal,
            });
          }
          UserStore.infinityClick(2);
        } else if (
          pathArray[2] === "subassetclassdetailsinfiniity" ||
          pathArray[2] === "subassetclassdetailsinfiniity_portfolio"
        ) {
          UserStore.setRef(Number(vehicleId), "infinity");
          UserStore.setInfinity("1");
          UserStore.setNormalHybirdFlow(true);
          UserStore.setMesurementId(UserStore.forThirdLevelMeasureId);

          UserStore.onToggleLive({
            assetClassId: assetClassId,
            vehicleId: vehicleId,
            measureId: pathArray[5],
            isInfinity: UserStore.isInfinity,
            signal,
          });
        }
      }

      return () => {
        // context.setIsLoading(true);
        abortController.abort();
      };
    }, [UserStore.isHydrated, PerformanceStore.isHydrated, location]);

    //const handleBreadClick = (index, data) => {};

    useEffect(() => {
      if (UserStore.isNoAssetClassPresent) setLoading(false);
    }, [UserStore.isNoAssetClassPresent]);

    return (
      <>
        <PageTitle title={"Sub Asset Class Details"} />
        {loading ||
        !UserStore.isHydrated ||
        (UserStore.isInfinity === "0" &&
          pathArray[2] !== "subassetclassdetailsQuick" &&
          pathArray[2] !== "subassetclassdetailshome" &&
          UserStore.portfolioLoader.portfolioSubLoader !== "success") ||
        ((pathArray[2] === "subassetclassdetailsQuick" ||
          pathArray[2] === "subassetclassdetailshome") &&
          UserStore.portfolioLoader.quickViewInfinity !== "success") ||
        (UserStore.isInfinity === "1" &&
          UserStore.portfolioLoader.infinitySubLoader !== "success") ? (
          <LoadingScreen />
        ) : (
          <>
            <Header type={context.type} />
            <div className="direct_equity_out_container">
              {!location.pathname.includes("_portfolio") && (
                <BreadCrumb
                  locationArr={UserStore.portfolioPath}
                  // clickFunction={(index, data) => handleBreadClick(index, data)}
                  parentName={"portfolio"}
                />
              )}
              {pathArray[2] === "subassetclassdetailshome" ||
              pathArray[2] === "subassetclassdetailsQuick" ? (
                <>
                  {/* <div className="direct_equity_out_container"> */}
                  <div className="homeInfinityPage">
                    <div className="title_container">
                      <img src={infinityQuickView} alt="infinity" />
                      <div className="title">
                        <PageHeading
                          headingClass=""
                          headingText={`${UserStore.selectedInstrumentVehicle?.modifiedVehicleData?.length} Instruments in`}
                        />
                        &nbsp;Infinity
                      </div>{" "}
                      <p className="portfolio_breadcr_title"></p>
                    </div>

                    <div className="amoutTitle">
                      <div className="details">
                        Total Current Value{" "}
                        <span>
                          {commaSeperated(
                            UserStore.totalCurrentValueFromHome.value,
                          )}
                        </span>{" "}
                        <span
                          style={{ fontFamily: "Encode Sans" }}
                          className="unitFont"
                        >
                          {UserStore.totalCurrentValueFromHome.value_type}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <SearchButton
                          search={search}
                          setSearch={(data) => {
                            setSearch(data);
                            startTransition(() => {
                              setSearch2(data);
                            });
                          }}
                          width={"423px"}
                        />
                      </div>
                    </div>

                    <div className="direct_equity_outside table_wrapper">
                      <Table
                        data={vertualRows}
                        columns={hybridColumns}
                        tableClass="equity_summary_table option7"
                        showColumnsOnly
                        EmptyStateBody={
                          <div
                            style={{
                              backgroundColor: "#F6F7FA",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              gap: "32px",
                              borderRadius: "15px",
                              height: "300px",
                              width: "100%",
                              marginTop: "20px",
                            }}
                          >
                            {!loading && (
                              <>
                                <img
                                  style={{
                                    width: "fit-content",
                                  }}
                                  src={nodataImage}
                                  alt="nodata"
                                />
                                <p
                                  style={{
                                    fontFamily: "Encode Sans",
                                    color: "#7E8899",
                                    fontWeight: "600",
                                    fontSize: "18px",
                                  }}
                                >
                                  No data found
                                </p>
                              </>
                            )}
                          </div>
                        }
                        handleSort={(key) => handleSortForTransaction(key)}
                        sortKey={filteredColumn}
                        isAscending={isAscendingForHeader}
                        d={1}
                        tableCaption={"Infinity instruments"}
                        setSortingAnnoucement={setSortingAnnoucement}
                      />
                    </div>
                  </div>
                  {/* </div> */}

                  <Modal
                    mdlStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
                    modalStyle={{
                      height: !UserStore.isHybridNormalInstrument
                        ? "510px"
                        : "490px",
                    }}
                    onClose={() => setOpenModal(false)}
                    open={openModal}
                    width={
                      document.documentElement.clientWidth > 1200
                        ? "1200px"
                        : "990px"
                    }
                    minWidth={"890px"}
                    modalContainerClass={`snapshot_modal_container quickviewModal ${
                      UserStore.isHybridNormalInstrument ? "hyrid" : ""
                    }`}
                    announcement={`instrument-details`}
                  >
                    {openModal && (
                      <TransactionModal
                        open={openModal}
                        transactions={transactionsData}
                        taxData={taxData}
                        loaderCondition={PerformanceStore.modalLoader}
                      />
                    )}
                  </Modal>
                </>
              ) : (
                <>
                  {/* <div className="direct_equity_out_container"> */}
                  <div className="direct_equity_outside">
                    {UserStore.isInfinity === "0" &&
                    UserStore.assetdData.length &&
                    UserStore.assetdData?.[0]?.assetId !== 0 ? (
                      <SubAssetTabs />
                    ) : (
                      ""
                    )}
                    <div
                      className={
                        UserStore.isInfinity === "0"
                          ? "direct_equity_nav_1 sub_asset_portfolio"
                          : "direct_equity_nav_1 "
                      }
                    >
                      <PageHeading
                        headingClass="heading-title"
                        headingText={
                          selectedInstrument?.vehicleData?.assetClass?.name ||
                          getSubAssetClasses(vehicleId)
                        }
                      />

                      {UserStore.isInfinity === "0" && (
                        <SelectNuvama
                          type={"all"}
                          handleWealth={(title) => handleWealth(title)}
                          setOpenFamilyModal={() => setOpenFamilyModal(true)}
                          withNuvama={withNuvama}
                          withOthers={withOthers}
                          selectedMember={selectedMember}
                          memberDropdownClass="analytics-members-dropdown"
                          memberDropdownTextClass="analytics-members-dropdown-text"
                          downArrowIcon={downArrowBlack}
                        />
                      )}
                    </div>
                    {UserStore.isNoAssetClassPresent ||
                    (UserStore.isNoDataSubAssetLevel &&
                      !UserStore.vehicleDataLength) ? (
                      <Noportfolio />
                    ) : (
                      <>
                        <div
                          className={`direct_equity_below ${
                            UserStore.isInfinity === "0"
                              ? "direct_equity_below_non_infinity"
                              : ""
                          }`}
                        >
                          {UserStore.isInfinity === "0" ? (
                            false ? (
                              <div>
                                <h2>
                                  <Skeleton />
                                </h2>
                                <Skeleton count={3} />
                              </div>
                            ) : (
                              <div className="direct_money_value_container">
                                {UserStore.callingLiveApi.tileDataLoading ? (
                                  <div className="money_values_second">
                                    <Skeleton
                                      count={1}
                                      height="25px"
                                      className="skel"
                                    />

                                    <Skeleton count={1} height="25px" />
                                    {/* <Skeleton count={3} />
                               <Skeleton count={3} />
                               <Skeleton count={3} />
                               <Skeleton count={3} />
                               <Skeleton count={3} />
                               <Skeleton count={3} /> */}
                                  </div>
                                ) : (
                                  <div className="money_values_first">
                                    <MoneyValue
                                      title="Current Value"
                                      hasWidth={true}
                                      amount={`${
                                        currentInvestmentReturns?.current_value
                                          ?.value || "-"
                                      }`}
                                      unitType={
                                        currentInvestmentReturns?.current_value
                                          ?.value_type || ""
                                      }
                                      date1={
                                        currentInvestmentReturns?.as_of_date
                                          ? "As on " +
                                            getDisplayDateWithoutWholeYear(
                                              currentInvestmentReturns?.as_of_date,
                                            )
                                          : "-"
                                      }
                                    />

                                    <MoneyValue
                                      title="Invested Value"
                                      hasWidth={true}
                                      amount={`${
                                        currentInvestmentReturns?.invested_value
                                          ?.value || "-"
                                      }`}
                                      unitType={
                                        currentInvestmentReturns?.invested_value
                                          ?.value_type || ""
                                      }
                                    />

                                    <MoneyValue
                                      hasWidth={true}
                                      title="Int/Div"
                                      amount={`${
                                        currentInvestmentReturns?.int_div
                                          ?.amount?.value || "-"
                                      } `}
                                      unitType={
                                        currentInvestmentReturns?.int_div
                                          ?.amount?.value_type || ""
                                      }
                                    />

                                    <MoneyValue
                                      hasWidth={true}
                                      title="Unrealised Gains (%)"
                                      amount={`${
                                        currentInvestmentReturns
                                          ?.unrealised_gain?.amount?.value ||
                                        "-"
                                      }`}
                                      unitType={
                                        currentInvestmentReturns
                                          ?.unrealised_gain?.amount
                                          ?.value_type || ""
                                      }
                                      batchAmount={
                                        currentInvestmentReturns
                                          ?.unrealised_gain?.percentage
                                      }
                                    />

                                    <MoneyValue
                                      hasWidth={true}
                                      title="Realised Gain"
                                      amount={`${
                                        currentInvestmentReturns?.realised_gain
                                          ?.amount?.value || "-"
                                      } `}
                                      unitType={
                                        currentInvestmentReturns?.realised_gain
                                          ?.amount?.value_type || ""
                                      }
                                    />
                                    <MoneyValue
                                      totalAndIrr={`${
                                        currentInvestmentReturns?.total_returns
                                          ?.value || "-"
                                      } `}
                                      totalAndUnit={
                                        currentInvestmentReturns?.total_returns
                                          ?.value_type || ""
                                      }
                                      title="Total Returns (IRR)"
                                      infoLogo={infoIcon2}
                                      amount={`${
                                        currentInvestmentReturns?.irr || "-"
                                      }${
                                        !!currentInvestmentReturns?.irr
                                          ? "%"
                                          : ""
                                      }`}
                                      hasWidth={true}
                                      TooltipContent={
                                        <div className="irr_tip tip_align">
                                          <h2>Total Returns</h2>
                                          <p>
                                            (Realised + Unrealised + Int/Div and
                                            Other Income)
                                          </p>
                                        </div>
                                      }
                                      tipClass="subAssetLevel"
                                      totalReturnSubAsset={true}
                                    />
                                    <FilterAllocation
                                      barcolor={
                                        allocationColorsStatic[
                                          selectedInstrument?.assetClassData?.id
                                        ]
                                      }
                                      title={"Allocation"}
                                      percentageAmout={
                                        selectedInstrument?.vehicleData
                                          ?.allocation_percentage
                                          ? selectedInstrument?.vehicleData
                                              ?.allocation_percentage + "%"
                                          : "-"
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            )
                          ) : (
                            <>
                              <div
                                className="marginSubAssetPage"
                                style={{
                                  position: "relative",
                                  display: "flex",
                                }}
                              >
                                <InfinityBackground />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "0px",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    className="inifinty_value_container_out marginSubAssetPage"
                                    style={{ margin: 0 }}
                                  >
                                    <div className="infinity_money_value_container asset_level">
                                      <MoneyValue
                                        title="Current Value"
                                        modalLogo={infoInfinity}
                                        setToolTipModalOpen={() =>
                                          setToolTipModalOpen(true)
                                        }
                                        amount={`${
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.current_value
                                            ?.value || "-"
                                        } `}
                                        unitType={
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.current_value
                                            ?.value_type || ""
                                        }
                                        date1={`As of ${
                                          getDisplayDate(
                                            selectedInstrument?.vehicleData
                                              ?.investmentreturn?.as_of_date,
                                          ) || ""
                                        }`}
                                        hasBackground={true}
                                        hasWidth={true}
                                      />
                                      <MoneyValue
                                        title="Invested Value"
                                        amount={`${
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.invested_value
                                            ?.value || "-"
                                        } `}
                                        unitType={
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.invested_value
                                            ?.value_type || ""
                                        }
                                        hasBackground={true}
                                        hasWidth={true}
                                      />
                                      <MoneyValue
                                        title="Unrealised Gains (%)"
                                        amount={`${
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.unrealised_gain
                                            ?.amount?.value || "-"
                                        }`}
                                        unitType={
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.unrealised_gain
                                            ?.amount?.value_type || ""
                                        }
                                        batchAmount={
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.unrealised_gain
                                            ?.percentage
                                        }
                                        hasBackground={true}
                                        hasWidth={true}
                                      />
                                      <MoneyValue
                                        title="Realised Gain"
                                        amount={`${
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.realised_gain
                                            ?.amount?.value || "-"
                                        }`}
                                        unitType={
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.realised_gain
                                            ?.amount?.value_type || ""
                                        }
                                        hasBackground={true}
                                        hasWidth={true}
                                      />
                                      <MoneyValue
                                        title="Total Returns (IRR)"
                                        infoLogo={infoInfinity}
                                        amount={`${
                                          selectedInstrument?.vehicleData
                                            ?.investmentreturn?.irr || "-"
                                        }%`}
                                        hasBackground={true}
                                        hasWidth={true}
                                        TooltipContent={
                                          <div className="irr_tip tip_align">
                                            <h2>Total Returns</h2>
                                            <p>
                                              (Realised + Unrealised + Int/Div
                                              and Other Income)
                                            </p>
                                          </div>
                                        }
                                        tipClass="subAssetLevel2"
                                      />
                                      <FilterAllocation
                                        barcolor={allocationColorsStatic[2]}
                                        title={"Allocation"}
                                        percentageAmout={
                                          selectedInstrument?.vehicleData
                                            ?.allocation_percentage
                                            ? selectedInstrument?.vehicleData
                                                ?.allocation_percentage + "%"
                                            : "-"
                                        }
                                        textColor={"white"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          <h2 className="portfolio_breadcr_title">
                            {/* *all values are in ₹ Lacs */}
                          </h2>
                        </div>
                        {!!selectedInstrument?.modifiedVehicleData && (
                          <>
                            <DirectEquityFilter
                              exportExcel={() => {
                                exportExcel({
                                  isInstrumentSummary: true,
                                  sheetname: `${
                                    UserStore.isInfinity !== "1"
                                      ? `${removeSymbol(
                                          selectedInstrument?.vehicleData
                                            ?.assetClass?.name,
                                        )} Instrument Summary`
                                      : `Infinity - ${removeSymbol(
                                          selectedInstrument?.vehicleData
                                            ?.assetClass?.name,
                                        )} Instrument Summary`
                                  }`,
                                  columns: getColumnsForPdf(),
                                  data:
                                    selectedTab === "infinity_pms" &&
                                    UserStore.isInfinity !== "1"
                                      ? // UserStore.selectedInstrumentVehicleInfinity
                                        //     ?.modifiedVehicleData
                                        UserStore.selectedInstrumentVehicle
                                          ?.modifiedInfinityInstrument
                                      : getFirstTimePdfTableData(),
                                  reportDetails: {
                                    relatioshipManager:
                                      UserStore?.exportDetails?.find(
                                        (item) => item.role === "RM",
                                      )?.name,
                                    serviceManager:
                                      UserStore?.exportDetails?.find(
                                        (item) => item.role === "CXO",
                                      )?.name,
                                    date: getPrintDate(
                                      UserStore.portfolio?.clientPortfolioReturn
                                        ?.as_of_date,
                                    ),
                                    clientName:
                                      UserStore.getData === "fam"
                                        ? UserStore.userData?.family_name
                                        : UserStore.userData?.full_name,
                                  },
                                  excelName: `${getPortfolioReportName()} - ${getCurrentDate()}`,
                                  customSheetName: getReportsSheetName({
                                    isInfinity: UserStore.isInfinity,
                                    selectedInstrument,
                                  }),
                                });
                              }}
                              exportPdf={() => {
                                // printDocument(instrumentSummaryId, {
                                //   width: 950,
                                //   height: 800,
                                //   name: getPortfolioReportName(),
                                // });

                                return downloadPDFFile({
                                  headerName: `${
                                    UserStore.isInfinity !== "1"
                                      ? `${removeSymbol(
                                          selectedInstrument?.vehicleData
                                            ?.assetClass?.name,
                                        )} Instrument Summary`
                                      : `Infinity - ${removeSymbol(
                                          selectedInstrument?.vehicleData
                                            ?.assetClass?.name,
                                        )} Instrument Summary`
                                  }`,
                                  fileId: instrumentSummaryId,
                                  name: getPortfolioReportName(),
                                  columns: getColumnsForPdf(),
                                  data:
                                    selectedTab === "infinity_pms" &&
                                    UserStore.isInfinity !== "1"
                                      ? // UserStore.selectedInstrumentVehicleInfinity
                                        //     ?.modifiedVehicleData
                                        UserStore.selectedInstrumentVehicle
                                          ?.modifiedInfinityInstrument
                                      : getFirstTimePdfTableData(),
                                });
                              }}
                              title2={
                                selectedInstrument?.vehicleData?.assetClass
                                  ?.name
                              }
                              search={search}
                              setSearch={(data, isClosed) => {
                                setSearch(data);
                                startTransition(() => {
                                  setSearch2(data);
                                });

                                if (isClosed) {
                                }
                              }}
                              toggle={isToggle}
                              onClick={() => {
                                setIsToggle((prevState) => Number(!prevState));
                                UserStore.setCallingLiveApi({
                                  tileDataLoading: true,
                                  tableDataLoading: true,
                                });
                                UserStore.changeIsLive();
                                UserStore.getLiveValues({
                                  assetClassId: 2,
                                  vehicleId: 15,
                                  signal,
                                });
                                //UserStore.onToggleLive({ assetClassId, vehicleId });
                              }}
                              restrictHover={
                                UserStore.callingSubAssetApi ||
                                UserStore.callingLiveApi.tableDataLoading
                              }
                            />
                          </>
                        )}

                        {UserStore.callingSubAssetApi ||
                        UserStore.callingLiveApi.tableDataLoading ? (
                          <div style={{ width: "100%", marginTop: "26px" }}>
                            {" "}
                            <TableSkeleton />
                          </div>
                        ) : // <div className="portfolio_loading_screen">
                        //   <img
                        //     className="loading_gif"
                        //     src={loaderGIF}
                        //     alt="loading..."
                        //   />
                        // </div>
                        selectedInstrument?.vehicleData?.id === 14 ||
                          selectedInstrument?.vehicleData?.id === 18 ? (
                          newSetItems?.[0] !== undefined ||
                          // UserStore.selectedInstrumentVehicleInfinity
                          //   ?.modifiedVehicleData[0] !== undefined
                          UserStore.selectedInstrumentVehicle
                            ?.modifiedInfinityInstrument?.[0] !== undefined ? (
                            <div className="show_tabs">
                              <Tabs
                                onSelect={(value) => {
                                  setTab(value);
                                }}
                                tabs={
                                  newSetItems?.[0] === undefined
                                    ? [
                                        {
                                          label: "Infinity PMS",
                                          value: "infinity_pms",
                                        },
                                      ]
                                    : //  UserStore.selectedInstrumentVehicleInfinity
                                      //     ?.modifiedVehicleData[0] === undefined
                                      UserStore.selectedInstrumentVehicle
                                          ?.modifiedInfinityInstrument?.[0] ===
                                        undefined
                                      ? [
                                          {
                                            label: `${selectedInstrument?.vehicleData?.assetClass?.name}`,
                                            value: "other_pms",
                                          },
                                        ]
                                      : [
                                          {
                                            label: `${selectedInstrument?.vehicleData?.assetClass?.name}`,
                                            value: "other_pms",
                                          },
                                          {
                                            label: "Infinity PMS",
                                            value: "infinity_pms",
                                          },
                                        ]
                                }
                                selectedTab={selectedTab}
                              />
                              {selectedTab === "other_pms" &&
                                !!selectedInstrument?.modifiedVehicleData &&
                                newSetItems?.[0] !== undefined && (
                                  <Table
                                    data={vertualRows}
                                    columns={columsOption5}
                                    classUnrealised={"lowerRightPadding"}
                                    tableClass={`equity_summary_table option5`}
                                    showColumnsOnly
                                    EmptyStateBody={
                                      <div
                                        style={{
                                          backgroundColor: "#F6F7FA",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexDirection: "column",
                                          gap: "32px",
                                          borderRadius: "15px",
                                          height: "300px",
                                          width: "100%",
                                          marginTop: "20px",
                                        }}
                                      >
                                        <img
                                          style={{
                                            width: "fit-content",
                                          }}
                                          src={nodataImage}
                                          alt="noData"
                                        />
                                        <p
                                          style={{
                                            fontFamily: "Encode Sans",
                                            color: "#7E8899",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                          }}
                                        >
                                          No data found
                                        </p>
                                      </div>
                                    }
                                    handleSort={(key) =>
                                      handleSortForTransaction(key)
                                    }
                                    sortKey={filteredColumn}
                                    isAscending={isAscendingForHeader}
                                    d={2}
                                    setSortingAnnoucement={
                                      setSortingAnnoucement
                                    }
                                  />
                                )}
                              {(selectedTab === "infinity_pms" ||
                                !newSetItems.length) &&
                                // UserStore.selectedInstrumentVehicleInfinity
                                //   ?.modifiedVehicleData[0] !== undefined
                                UserStore.selectedInstrumentVehicle
                                  ?.modifiedInfinityInstrument?.[0] !==
                                  undefined && (
                                  <Table
                                    data={vertualRowsInfinity}
                                    columns={hybridColumns}
                                    classUnrealised={"lowerRightPadding"}
                                    tableClass="equity_summary_table option6"
                                    showColumnsOnly
                                    EmptyStateBody={
                                      <div
                                        style={{
                                          backgroundColor: "#F6F7FA",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexDirection: "column",
                                          gap: "32px",
                                          borderRadius: "15px",
                                          height: "300px",
                                          width: "100%",
                                          marginTop: "20px",
                                        }}
                                      >
                                        <img
                                          style={{
                                            width: "fit-content",
                                          }}
                                          src={nodataImage}
                                          alt="noData"
                                        />
                                        <p
                                          style={{
                                            fontFamily: "Encode Sans",
                                            color: "#7E8899",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                          }}
                                        >
                                          No data found
                                        </p>
                                      </div>
                                    }
                                    handleSort={(key) =>
                                      handleSortForInfinity(key)
                                    }
                                    sortKey={filteredColumnInfinity}
                                    isAscending={isAscendingForHeaderInfinity}
                                    d={3}
                                    setSortingAnnoucement={
                                      setSortingAnnoucement
                                    }
                                  />
                                )}
                            </div>
                          ) : (
                            <NoDataPortfolio />
                          )
                        ) : (
                          <>
                            <div
                              style={{
                                backgroundColor: "#FFF",
                                height: 12,
                                width: "100%",
                                position: "sticky",
                                top: 0,
                              }}
                            />
                            {!!selectedInstrument?.modifiedVehicleData && (
                              <Table
                                data={vertualRows}
                                columns={
                                  UserStore.isInfinity === "1"
                                    ? columnsOption1
                                    : // : selectedInstrument?.assetClassData?.id === 3
                                      // ? hybridColumns
                                      getColumns() || []
                                }
                                classUnrealised={"lowerRightPadding"}
                                tableClass={`equity_summary_table ${getClass()}`}
                                showColumnsOnly
                                EmptyStateBody={
                                  <div
                                    style={{
                                      backgroundColor: "#F6F7FA",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexDirection: "column",
                                      gap: "32px",
                                      borderRadius: "15px",
                                      height: "300px",
                                      width: "100%",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {!loading && (
                                      <>
                                        <img
                                          style={{
                                            width: "fit-content",
                                          }}
                                          src={nodataImage}
                                          alt="noData"
                                        />
                                        <p
                                          style={{
                                            fontFamily: "Encode Sans",
                                            color: "#7E8899",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                          }}
                                        >
                                          No data found
                                        </p>
                                      </>
                                    )}
                                  </div>
                                }
                                handleSort={(key) =>
                                  handleSortForTransaction(key)
                                }
                                sortKey={filteredColumn}
                                isAscending={isAscendingForHeader}
                                isTableLoader={isAscendingForHeader}
                                d={4}
                                tableCaption={`${
                                  selectedInstrument?.vehicleData?.assetClass
                                    ?.name || getSubAssetClasses(vehicleId)
                                } Instruments`}
                                setSortingAnnoucement={setSortingAnnoucement}
                              />
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  <Modal
                    mdlStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
                    modalStyle={{
                      height: !UserStore.isHybridNormalInstrument
                        ? "510px"
                        : "490px",
                    }}
                    onClose={() => setOpenModal(false)}
                    open={openModal}
                    width={
                      document.documentElement.clientWidth > 1200
                        ? "1200px"
                        : "990px"
                    }
                    minWidth={"890px"}
                    modalContainerClass={`snapshot_modal_container quickviewModal ${
                      UserStore.isHybridNormalInstrument ? "hyrid" : ""
                    }`}
                    announcement={`instrument-details`}
                  >
                    {openModal && (
                      <TransactionModal
                        open={openModal}
                        transactions={transactionsData}
                        taxData={taxData}
                        loaderCondition={PerformanceStore.modalLoader}
                      />
                    )}
                  </Modal>
                  <Modal
                    onClose={() => setOpenFamilyModal(false)}
                    open={openFamilyModal}
                    title={family_modal_title}
                    width={"810px"}
                  >
                    <ModalFamily
                      setSelectedMember={(id) => setSelectedMember(id)}
                      selectedMember={selectedMember}
                      onClose={() => setOpenFamilyModal(false)}
                    />
                  </Modal>
                  <Modal
                    onClose={() => setToolTipModalOpen(false)}
                    title={"Current Value"}
                    width={"861px"}
                    showCloseIcon={false}
                    open={tooltipModalOpen}
                  >
                    <OthersModalContent />
                  </Modal>
                  <div>
                    {/* <PdfTable
                      headerName={`${
                        UserStore.isInfinity !== "1"
                          ? `${removeSymbol(
                              selectedInstrument?.vehicleData?.assetClass?.name,
                            )} Instrument Summary`
                          : `Infinity - ${removeSymbol(
                              selectedInstrument?.vehicleData?.assetClass?.name,
                            )} Instrument Summary`
                      }`}
                      columns={getColumnsForPdf()}
                      data={
                        selectedTab === "infinity_pms" &&
                        UserStore.isInfinity !== "1"
                          ? // UserStore.selectedInstrumentVehicleInfinity
                            //     ?.modifiedVehicleData
                            UserStore.selectedInstrumentVehicle
                              ?.modifiedInfinityInstrument
                          : getFirstTimePdfTableData()
                      }
                      id={instrumentSummaryId}
                    /> */}
                  </div>
                </>
              )}
              <div
                id="aria-announcer"
                aria-live="polite"
                aria-atomic="true"
                className="sr-only"
              >
                {sortingAnnoucement}
              </div>
            </div>
          </>
        )}
      </>
    );
  },
);

export default DirectEquitySummary;
